<template>
  <div class="app">
      <div  v-if="$route.name === 'home'">
      <div id="header_top" class="header">
        <div class="row contenu-header">
            <div v-on:click="show_sidenav=true;" class="col-2 hidden-md button-menu">
                <img v-show="show_logo_white" class="titre-logo" :src="images.menu" style="width:25px"> 
                <img v-show="!show_logo_white" class="titre-logo" :src="images.menu_bottom" style="width:25px"> 
            </div>
            <div class="col-2 col-sm-1 col-md-1">
              <router-link to="/" >
                      <img v-show="show_logo_white" class="titre-logo" :src="images.logo" style="width:50px;">         
                      <img v-show="!show_logo_white" class="titre-logo" :src="images.logo_bottom" style="width:50px">  
                              
              </router-link>
            </div>
            <router-link to="/" class="hidden-xs col-sm-3 col-md-3 link-header-2">
              Twill Studio
            </router-link>
            
            <router-link to="/" class="col-2 hidden-md link-header-2">
              Twill
            </router-link>    
              
            <div class="col-2 col-sm-2 col-md-2" ></div>
            <router-link @mouseover.native="show_menu_solution=false;show_menu_company = false" to="/portfolio" class="hidden-xs col-sm-1 col-md-1 link-header" style="padding-top:15px;">
            Portfolio
            </router-link>
            <button  v-on:mouseover="show_menu_company=false;show_menu_solution = true" class="hidden-xs col-sm-1 col-md-1 link-header">
            Solutions&nbsp;
            <img v-if="show_menu_solution" :src="images.scroll_grey_open" style="width:10px">
            <img v-else :src="images.scroll_grey" style="width:10px">
            </button>
            <router-link @mouseover.native="show_menu_solution=false;show_menu_company = false" to="/price" class="hidden-xs col-sm-1 col-md-1 link-header" style="padding-top:15px;">
            Pricing
            </router-link>
            <div class="hidden-xs hidden-md logo-mobile">
              <router-link to="/"><img :src="images.trefle" style="width:60px;padding-left:24px;"></router-link>
            </div>
            <button  v-on:mouseover="show_menu_solution=false;show_menu_company = true" class="hidden-xs col-sm-1 col-md-1 link-header">
            Company&nbsp;
            <img v-if="show_menu_company" :src="images.scroll_grey_open" style="width:10px">
            <img v-else :src="images.scroll_grey" style="width:10px">
            </button>
            <!--
            <router-link @mouseover.native="show_menu_solution=false;show_menu_company = false" to="/process" class="hidden-xs col-sm-1 col-md-1 link-header" style="padding-top:15px;">
            Process
            </router-link>
            -->
            <div v-on:click='show_contact_form = !show_contact_form'  class="hidden-md col-4 col-sm-1 col-md-1 div-button-contact-menu">
              <button id="button-contact-menu-scroll-top" class="button-contact-menu">Contact
              </button>
            </div>  
            <div v-on:click='show_contact_form_web = !show_contact_form_web'  class="hidden-xs col-4 col-sm-1 col-md-1 div-button-contact-menu">
              <button id="button-contact-menu-scroll-top" class="button-contact-menu">Contact
              </button>
            </div>  
            <div class="hidden-xs col-sm-1 col-md-1"></div> 

            <div class="row" style="width:100%;margin-left:0px;" >
              <div v-on:mouseover="show_menu_solution=false;show_menu_company = false" class="hidden-xs col-sm-6 col-md-7"></div>  
                <div  v-if="show_menu_solution" class="menu-solution col-md-3">
                    <img :src="images.triangle" style="width:20px;position:absolute;top:-1.20rem;margin-left:25px;">
                  <div class="row" style="width:100%;margin-left:0px;text-align:left;font-size:16px;">
                    <div class="col-md-12">
                      We provide our <img :src="images.french_flag" style="width:20px;border-radius:2px;"> Touch
                    </div>
                    <div class="col-md-12 nopadding">
                      <hr style="background-color:white;">
                    </div>
                  </div>
                  <router-link to="/website" class="row link-menu-deroulant">
                    <div class="col-md-3" style="text-align:right;">
                      <img :src="images.website" style="width:25px;">
                    </div>
                    <div class="col-md-9">
                      Web app
                    </div>
                  </router-link>
                  <router-link to="/application" class="row link-menu-deroulant">
                    <div class="col-md-3" style="text-align:right;padding-right:20px;">
                      <img :src="images.app" style="width:15px;">
                    </div>
                    <div class="col-md-9">
                      Mobile app
                    </div>
                  </router-link>
                  <router-link to="/api" class="row link-menu-deroulant">
                    <div class="col-md-3" style="text-align:right;">
                      <img :src="images.api" style="width:25px;">
                    </div>
                    <div class="col-md-9">
                      Data Management
                    </div>
                  </router-link>
                  <router-link to="/map" class="row link-menu-deroulant">
                    <div class="col-md-3" style="text-align:right;">
                      <img :src="images.map" style="width:23px;">
                    </div>
                    <div class="col-md-9">
                      Map visualization
                    </div>
                  </router-link>
                </div>
                <div   v-if="show_menu_company" class="menu-company col-md-3">
                  <img :src="images.triangle" style="width:20px;position:absolute;top:-1.20rem;margin-left:270px;">
                  <div class="row" style="width:100%;margin-left:0px;text-align:left;font-size:16px;">
                    <div class="col-md-12">
                      Why Twill ?
                    </div>
                    <div class="col-md-12 nopadding">
                      <hr style="background-color:white;">
                    </div>
                  </div>
                  <div class="row link-menu-company">
                    <div class="col-md-3" style="text-align:right;">
                      <img :src="images.tick_white" style="width:20px;">
                    </div>
                    <div class="col-md-9">
                      The technologies
                    </div>
                  </div>
                  <div class="row link-menu-company">
                    <div class="col-md-3" style="text-align:right;">
                      <img :src="images.tick_white" style="width:20px;">
                    </div>
                    <div class="col-md-9">
                      The process
                    </div>
                  </div>
                  <div class="row link-menu-company">
                    <div class="col-md-3" style="text-align:right;">
                      <img :src="images.tick_white" style="width:20px;">
                    </div>
                    <div class="col-md-9">
                      The team
                    </div>
                  </div>
                  <div class="row" style="text-align:center">
                      <div class="col-md-4"></div>
                      <router-link to="/discover" class="button-discover-company col-md-4">Discover</router-link>
                      <div class="col-md-4"></div>
                  </div>
                </div>
                <div v-on:mouseover="show_menu_solution=false;show_menu_company = false" class="hidden-xs col-sm-3 col-md-3"></div>
            </div>
            <!--
            <div  class="col-sm-3 col-md-3 menu-company" v-if="show_menu_company">
                <img :src="images.triangle" style="width:20px;position:absolute;top:-0.99rem;margin-left:25px;">
              Our Company<br>
              <hr style="background-color:white;">
              yo
            </div>
            -->
        </div>
      </div>
      </div>
      <div v-else>
      <div  class="header-fixe">
        <div class="row contenu-header">
            <div v-on:click="show_sidenav=true;" class="col-2 hidden-md button-menu">
                <img class="titre-logo" :src="images.menu_bottom" style="width:25px"> 
            </div>
            <div class="col-2 col-sm-1 col-md-1">
              <router-link to="/" >        
                      <img class="titre-logo" :src="images.logo_bottom" style="width:50px">        
              </router-link>
            </div>
            <router-link to="/" class="hidden-xs col-sm-3 col-md-3 link-header-2">
              Twill Studio
            </router-link>
            
            <router-link to="/" class="col-2 hidden-md link-header-2">
              Twill
            </router-link>    
              
            <div class="col-2 col-sm-2 col-md-2" ></div>
            <router-link @mouseover.native="show_menu_solution=false;show_menu_company = false" to="/portfolio" class="hidden-xs col-sm-1 col-md-1 link-header" style="padding-top:15px;">
            Portfolio
            </router-link>
            <button   v-on:mouseover="show_menu_company=false;show_menu_solution = true" class="hidden-xs col-sm-1 col-md-1 link-header">
            Solutions&nbsp;
            <img v-if="show_menu_solution" :src="images.scroll_grey_open" style="width:10px">
            <img v-else :src="images.scroll_grey" style="width:10px">
            </button>
            <router-link @mouseover.native="show_menu_solution=false;show_menu_company = false" to="/price" class="hidden-xs col-sm-1 col-md-1 link-header" style="padding-top:15px;">
            Pricing
            </router-link>
            <div class="hidden-xs hidden-md logo-mobile">
              <router-link to="/"><img :src="images.trefle" style="width:60px;padding-left:24px;"></router-link>
            </div>
            <button  v-on:mouseover="show_menu_solution=false;show_menu_company = true" class="hidden-xs col-sm-1 col-md-1 link-header">
            Company&nbsp;
            <img v-if="show_menu_company" :src="images.scroll_grey_open" style="width:10px">
            <img v-else :src="images.scroll_grey" style="width:10px">
            </button>
            <!--
            <router-link @mouseover.native="show_menu_solution=false;show_menu_company = false" to="/process" class="hidden-xs col-sm-1 col-md-1 link-header" style="padding-top:15px;">
            Process
            </router-link>
            -->
            <div v-on:click='show_contact_form = !show_contact_form'  class="hidden-md col-4 col-sm-1 col-md-1 div-button-contact-menu">
              <button id="button-contact-menu-scroll-top" class="button-contact-menu">Contact
              </button>
            </div>  
            <div v-on:click='show_contact_form_web = !show_contact_form_web'  class="hidden-xs col-4 col-sm-1 col-md-1 div-button-contact-menu">
              <button id="button-contact-menu-scroll-top" class="button-contact-menu">Contact
              </button>
            </div>  
            <div class="hidden-xs col-sm-1 col-md-1"></div> 

            <div class="row" style="width:100%;margin-left:0px;" >
              <div v-on:mouseover="show_menu_solution=false;show_menu_company = false" class="hidden-xs col-sm-6 col-md-7"></div>  
                <div  v-if="show_menu_solution" class="menu-solution col-md-3">
                    <img :src="images.triangle" style="width:20px;position:absolute;top:-1.20rem;margin-left:25px;">
                  <div class="row" style="width:100%;margin-left:0px;text-align:left;font-size:16px;">
                    <div class="col-md-12">
                      We provide our <img :src="images.french_flag" style="width:20px;border-radius:2px;"> Touch
                    </div>
                    <div class="col-md-12 nopadding">
                      <hr style="background-color:white;">
                    </div>
                  </div>
                  <router-link to="/website" class="row link-menu-deroulant">
                    <div class="col-md-3" style="text-align:right;">
                      <img :src="images.website" style="width:25px;">
                    </div>
                    <div class="col-md-9">
                      Web app
                    </div>
                  </router-link>
                  <router-link to="/application" class="row link-menu-deroulant">
                    <div class="col-md-3" style="text-align:right;padding-right:20px;">
                      <img :src="images.app" style="width:15px;">
                    </div>
                    <div class="col-md-9">
                      Mobile app
                    </div>
                  </router-link>
                  <router-link to="/api" class="row link-menu-deroulant">
                    <div class="col-md-3" style="text-align:right;">
                      <img :src="images.api" style="width:25px;">
                    </div>
                    <div class="col-md-9">
                      Data Management
                    </div>
                  </router-link>
                  <router-link to="/map" class="row link-menu-deroulant">
                    <div class="col-md-3" style="text-align:right;">
                      <img :src="images.map" style="width:23px;">
                    </div>
                    <div class="col-md-9">
                      Map visualization
                    </div>
                  </router-link>
                </div>
                <div   v-if="show_menu_company" class="menu-company col-md-3">
                  <img :src="images.triangle" style="width:20px;position:absolute;top:-1.20rem;margin-left:270px;">
                  <div class="row" style="width:100%;margin-left:0px;text-align:left;font-size:16px;">
                    <div class="col-md-12">
                      Why Twill ?
                    </div>
                    <div class="col-md-12 nopadding">
                      <hr style="background-color:white;">
                    </div>
                  </div>
                  <div class="row link-menu-company">
                    <div class="col-md-3" style="text-align:right;">
                      <img :src="images.tick_white" style="width:20px;">
                    </div>
                    <div class="col-md-9">
                      The technologies
                    </div>
                  </div>
                  <div class="row link-menu-company">
                    <div class="col-md-3" style="text-align:right;">
                      <img :src="images.tick_white" style="width:20px;">
                    </div>
                    <div class="col-md-9">
                      The process
                    </div>
                  </div>
                  <div class="row link-menu-company">
                    <div class="col-md-3" style="text-align:right;">
                      <img :src="images.tick_white" style="width:20px;">
                    </div>
                    <div class="col-md-9">
                      The team
                    </div>
                  </div>
                  <div class="row" style="text-align:center">
                      <div class="col-md-4"></div>
                      <router-link to="/discover" class="button-discover-company col-md-4">Discover</router-link>
                      <div class="col-md-4"></div>
                  </div>
                </div>
                <div v-on:mouseover="show_menu_solution=false;show_menu_company = false" class="hidden-xs col-sm-3 col-md-3"></div>
            </div>
            <!--
            <div  class="col-sm-3 col-md-3 menu-company" v-if="show_menu_company">
                <img :src="images.triangle" style="width:20px;position:absolute;top:-0.99rem;margin-left:25px;">
              Our Company<br>
              <hr style="background-color:white;">
              yo
            </div>
            -->
        </div>
      </div>
      </div> 

    <div v-if="show_contact_form" style="position:fixed;width:100%;height:100vh;"></div>
    <div v-else>
      <transition name="fade">
        <div id="mySidenav" v-if="show_sidenav" class="sidenav">
          <div style="height:auto;">
            <div class="row row-1">
              <div class="col-12">
                <button class="button-close"><img v-on:click="show_sidenav=false" :src="images.close" style="width:22px;"></button>
              </div>
              <div class="col-12" style="padding-top:20px;text-align:center;">
                <img :src="images.logo_sidenav" style="width:80px;">
              </div>
              <div class="col-12" style="padding-top:10px;text-align:center;color:white;font-size:18px;margin-bottom:20px;">
                Twill Studio
              </div>
              <router-link v-if="$route.name === 'home'" to="/" @click.native="show_sidenav=false" class="col-12 link-ligne-sidenav-active">
                <div class="row row-1">
                  <div class="col-3">
                    <img :src="images.home_footer_off" style="width:20px;padding-bottom:3px;">
                  </div>
                  <div class="col-7">
                    Home
                  </div>
                  <div class="col-1">
                    <img :src="images.fleche_droite" style="width:10px;">
                  </div>
                </div>
              </router-link>
              <router-link v-else to="/" @click.native="show_sidenav=false" class="col-12 link-ligne-sidenav">
                <div class="row row-1">
                  <div class="col-3">
                    <img :src="images.home_footer_off" style="width:20px;padding-bottom:3px;">
                  </div>
                  <div class="col-7">
                    Home
                  </div>
                  <div class="col-1">
                    <img :src="images.fleche_droite" style="width:10px;">
                  </div>
                </div>
              </router-link>  

              <div v-on:click="show_solutions=!show_solutions" class="col-12 link-ligne-sidenav-solution" style="margin-bottom:0px;">
                <div class="row row-1">
                  <div class="col-3">
                    <img :src="images.solution" style="width:17px;padding-bottom:3px;padding-left:2px;">
                  </div>
                  <div class="col-7">
                    Solution
                  </div>
                  <div  v-if="show_solutions" class="col-1">
                    <img :src="images.scroll" style="width:15px;">
                  </div>
                  <div v-else class="col-1">
                    <img  :src="images.fleche_droite" style="width:10px;">
                  </div>
                </div>
              </div>   

        
                <div v-if="show_solutions" class="col-12 nopadding" style="margin-bottom:10px;color:white">
                  <router-link v-if="$route.name === 'website'" @click.native="show_sidenav=false" to="/website" class="row row-1 link-ligne-sidenav-active-solution">
                    <div class="col-2"></div>
                    <div class="col-1">
                      <img :src="images.website" style="width:20px;padding-bottom:3px;">
                    </div>
                    <div class="col-7">
                      Web
                    </div>
                  </router-link>
                  <router-link v-else @click.native="show_sidenav=false" to="/website" class="row row-1 link-ligne-sidenav-solution-2">
                    <div class="col-2"></div>
                    <div class="col-1">
                      <img :src="images.website" style="width:20px;padding-bottom:3px;">
                    </div>
                    <div class="col-7">
                      Web
                    </div>
                  </router-link>

                  <router-link v-if="$route.name === 'application'" @click.native="show_sidenav=false" to="/application" class="row row-1 link-ligne-sidenav-active-solution">
                    <div class="col-2"></div>
                    <div class="col-1">
                      <img :src="images.app" style="width:15px;padding-bottom:3px;">
                    </div>
                    <div class="col-7">
                      Mobile
                    </div>
                  </router-link>
                  <router-link v-else @click.native="show_sidenav=false" to="/application" class="row row-1 link-ligne-sidenav-solution-2">
                    <div class="col-2"></div>
                    <div class="col-1">
                      <img :src="images.app" style="width:15px;padding-bottom:3px;">
                    </div>
                    <div class="col-7">
                      Mobile
                    </div>
                  </router-link>

                  <router-link v-if="$route.name === 'api'" @click.native="show_sidenav=false" to="/api" class="row row-1 link-ligne-sidenav-active-solution">
                    <div class="col-2"></div>
                    <div class="col-1">
                      <img :src="images.api" style="width:20px;padding-bottom:3px;">
                    </div>
                    <div class="col-7">
                      Data
                    </div>
                  </router-link>
                  <router-link v-else @click.native="show_sidenav=false" to="/api" class="row row-1 link-ligne-sidenav-solution-2">
                    <div class="col-2"></div>
                    <div class="col-1">
                      <img :src="images.api" style="width:20px;padding-bottom:3px;">
                    </div>
                    <div class="col-7">
                      Data
                    </div>
                  </router-link>

                  <router-link v-if="$route.name === 'map'" @click.native="show_sidenav=false" to="/map" class="row row-1 link-ligne-sidenav-active-solution">
                    <div class="col-2"></div>
                    <div class="col-1">
                      <img :src="images.map" style="width:15px;padding-bottom:3px;">
                    </div>
                    <div class="col-7">
                      Map
                    </div>
                  </router-link>
                  <router-link v-else @click.native="show_sidenav=false" to="/map" class="row row-1 link-ligne-sidenav-solution-2">
                    <div class="col-2"></div>
                    <div class="col-1">
                      <img :src="images.map" style="width:20px;padding-bottom:3px;">
                    </div>
                    <div class="col-7">
                      Map
                    </div>
                  </router-link>
                </div>
        

              <router-link v-if="$route.name === 'price'" to="/price" @click.native="show_sidenav=false" class="col-12 link-ligne-sidenav-active">
                <div class="row row-1">
                  <div class="col-3">
                    <img :src="images.price" style="width:20px;padding-bottom:3px;">
                  </div>
                  <div class="col-7">
                    Pricing
                  </div>
                  <div class="col-1">
                    <img :src="images.fleche_droite" style="width:10px;">
                  </div>
                </div>
              </router-link>
              <router-link v-else to="/price" @click.native="show_sidenav=false" class="col-12 link-ligne-sidenav">
                <div class="row row-1">
                  <div class="col-3">
                    <img :src="images.price" style="width:20px;padding-bottom:3px;">
                  </div>
                  <div class="col-7">
                    Pricing
                  </div>
                  <div class="col-1">
                    <img :src="images.fleche_droite" style="width:10px;">
                  </div>
                </div>
              </router-link>  

              <router-link v-if="$route.name === 'discover'" to="/discover" @click.native="show_sidenav=false" class="col-12 link-ligne-sidenav-active">
                <div class="row row-1">
                  <div class="col-3">
                    <img :src="images.discover" style="width:20px;padding-bottom:3px;">
                  </div>
                  <div class="col-7">
                    Discover
                  </div>
                  <div class="col-1">
                    <img :src="images.fleche_droite" style="width:10px;">
                  </div>
                </div>
              </router-link>
              <router-link v-else to="/discover" @click.native="show_sidenav=false" class="col-12 link-ligne-sidenav">
                <div class="row row-1">
                  <div class="col-3">
                    <img :src="images.discover" style="width:20px;padding-bottom:3px;">
                  </div>
                  <div class="col-7">
                    Discover
                  </div>
                  <div class="col-1">
                    <img :src="images.fleche_droite" style="width:10px;">
                  </div>
                </div>
              </router-link>  

              <router-link v-if="$route.name === 'process'" to="/process" @click.native="show_sidenav=false" class="col-12 link-ligne-sidenav-active">
                <div class="row row-1">
                  <div class="col-3">
                    <img :src="images.process_footer" style="width:20px;padding-bottom:3px;">
                  </div>
                  <div class="col-7">
                    Process
                  </div>
                  <div class="col-1">
                    <img :src="images.fleche_droite" style="width:10px;">
                  </div>
                </div>
              </router-link>
              <router-link v-else to="/portfolio" @click.native="show_sidenav=false" class="col-12 link-ligne-sidenav">
                <div class="row row-1">
                  <div class="col-3">
                    <img :src="images.process_footer" style="width:20px;padding-bottom:3px;">
                  </div>
                  <div class="col-7">
                    Portfolio
                  </div>
                  <div class="col-1">
                    <img :src="images.fleche_droite" style="width:10px;">
                  </div>
                </div>
              </router-link> 

              <div v-on:click='show_contact_form = !show_contact_form;' class="col-12 link-ligne-sidenav">
                <div class="row row-1">
                  <div class="col-3">
                    <img :src="images.contact_footer" style="width:20px;padding-bottom:3px;">
                  </div>
                  <div class="col-7">
                    Contact
                  </div>
                  <div class="col-1">
                    <img :src="images.fleche_droite" style="width:10px;">
                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>
      
      </transition>  

  


      <div v-on:mouseover='show_menu_solution = false;show_sidenav=false;show_menu_company = false' id = "main" class="contenu">
          <router-view @openContact="openContact" @openContactWeb="openContactWeb" v-on:click='show_sidenav=false'></router-view>
      </div>


      <footer class="footer">
        <div class="row contenu-footer">
          <div class="hidden-xs col-sm-2 col-md-2"></div>
          <div class="col-6 col-sm-2 col-md-2">
            <p class="titre-colone-footer">SOLUTIONS</p>
            <router-link to="/website" class="link-footer">Website</router-link><br>
            <router-link to="/application" class="link-footer">Mobile</router-link><br>
            <router-link to="/api" class="link-footer">Data</router-link><br>
            <router-link to="/map" class="link-footer">Map</router-link><br>
          </div>
          <div class="col-6 col-sm-2 col-md-2">
            <p class="titre-colone-footer">INFORMATION</p>
            <router-link to="/price" class="link-footer">Pricing</router-link><br>
            <router-link to="/process" class="link-footer">Process</router-link><br>
          </div>
          <div class="col-6 col-sm-2 col-md-2">
            <p class="titre-colone-footer">COMPANY</p>
            <router-link to="/discover" class="link-footer">About</router-link><br>
            <router-link to="/jobs" class="link-footer">Jobs</router-link>&nbsp;<a class="cadre-addin-footer">&nbsp;&nbsp;Hiring&nbsp;&nbsp;</a><br>
            <a href="https://www.linkedin.com/company/twill-studio/" target="_blank" class="link-footer">Linkedin</a><br>
          </div>
          <div class="col-6 col-sm-2 col-md-2">
            <p class="titre-colone-footer">CONTACT</p>
            <div v-on:click='show_contact_form_web = !show_contact_form_web;' class="hidden-xs link-footer">Contact us</div>
            <div v-on:click='show_contact_form = !show_contact_form;' class="hidden-md link-footer">Contact us</div>
          </div>
          <div class="hidden-xs col-sm-2 col-md-2"></div>
          <div class="col-12 col-sm-12 col-md-12">
            <hr style="background-color:#D8D8D8;margin-right:100px;margin-left:100px;margin-top:30px">
          </div>
          <div class="col-1 col-sm-1 col-md-1 logo-footer">
            <simple-svg class="titre-logo" :filepath="images.logo" :color="'white'" :width="'40px'" :height="'30px'" />
          </div>
          <div class="col-4 col-sm-1 col-md-1 titre-logo-footer">
            Twill studio
          </div>
          <div class="col-6 col-sm-4 col-md-4 all-right-footer">
            All Rights Reserved 2018
          </div>
          
        </div>
      </footer>
    </div>
<!--
    <div class="hidden-md footer-fixed">
      <div class="row">
        <router-link to="/" style="text-decoration:none;" class="col-3 button-footer-fixed">
               <div v-if="$route.name === 'home'" style="color:#232F43">
                 <img :src="images.home_footer" style="width:30px;"><br>
                 Home
                 </div>  
              <div v-else style="color:#9B9B9B">
                 <img :src="images.home_footer_off" style="width:30px;"><br>
                 Home
              </div> 
        </router-link>    
        <router-link to="/website" style="text-decoration:none;" class="col-3 button-footer-fixed">
               <div v-if="$route.name === 'website'" style="color:#232F43">
                 <img :src="images.home_footer" style="width:30px;"><br>
                 Web
                 </div>  
              <div v-else style="color:#9B9B9B">
                 <img :src="images.home_footer_off" style="width:30px;"><br>
                 Web
              </div> 
        </router-link>   
        <router-link to="/process" style="text-decoration:none;" class="col-3 button-footer-fixed">
               <div v-if="$route.name === 'process'" style="color:#232F43">
                 <img :src="images.process_footer" style="width:30px;"><br>
                 Process
                 </div>  
              <div v-else style="color:#9B9B9B">
                 <img :src="images.process_footer_off" style="width:30px;"><br>
                 Process
              </div> 
        </router-link>  
        <router-link to="/contact" style="text-decoration:none;" class="col-3 button-footer-fixed">
               <div v-if="$route.name === 'contact'" style="color:#232F43">
                 <img :src="images.contact_footer" style="width:30px;margin-bottom:10px"><br>
                 Contact
                 </div>  
              <div v-else style="color:#9B9B9B">
                 <img :src="images.contact_footer_off" style="width:30px;margin-bottom:10px"><br>
                 Contact
              </div> 
        </router-link>    
      </div>
    </div>
-->



  <form v-on:submit.prevent="addMessage" v-on:click='show_sidenav=false' v-if="show_contact_form" class="row ligne-contact-form hidden-md">    
      
      <div class="hidden-xs col-9"></div>
      <div class="col-12 col-md-3 blue-form-contact">
        <div class="row" style="width:100%;margin-left:0px;">
        
        <h2 class="title-contact-form">Do you need developers for a project ?</h2>
        <h2 class="title-contact-form">Tell us more about it...</h2>
          <input v-model="newMessage.name" class="input-contact col-12 col-md-12" type="text" placeholder="Your Name" >
          <input v-model="newMessage.email" class="input-contact col-12 col-md-12" type="text" placeholder="Your Email">
          <input v-model="newMessage.company" class="input-contact col-12 col-md-12" type="text" placeholder="Your Company">
          <textarea v-model="newMessage.message" class="input-contact col-12 col-md-12" type="text" placeholder="Your Message" style="height:120px;padding-top:10px;"></textarea>

        <!--
        <input v-model="newMessage.company" class="input input-contact" type="text" placeholder="Your Company">
        <textarea v-model="newMessage.message" class="input input-contact" type="text" style="height:120px;" placeholder="Your Message"></textarea>
        --> 
  
        
          <div class="col-6 col-md-12">
            <button type="submit" v-on:click="show_contact_form=false;show_contact_form_web=false;" class="button-send-message">Send</button>
          </div>
          <div class="col-6 hidden-md">
            <div v-on:click="show_contact_form=false;show_contact_form_web=false;" class="button-send-message-cancel">Cancel</div>
          </div>
        </div>
          
      
    </div>
  </form>


<transition name="slideUp" class="hidden-xs">
  <form v-on:submit.prevent="addMessage" v-on:click='show_sidenav=false' v-if="show_contact_form_web" class="row ligne-contact-form hidden-xs">        
      <div class="hidden-xs col-9"></div>
      <div class="col-12 col-md-3 blue-form-contact">
        <div class="row" style="width:100%;margin-left:0px;">
        
        <h2 class="title-contact-form">Do you need developers for a project ?</h2>
        <h2 class="title-contact-form">Tell us more about it...</h2>
          <input v-model="newMessage.name" class="input-contact col-12 col-md-12" type="text" placeholder="Your Name" >
          <input v-model="newMessage.email" class="input-contact col-12 col-md-12" type="text" placeholder="Your Email">
          <input v-model="newMessage.company" class="input-contact col-12 col-md-12" type="text" placeholder="Your Company">
          <textarea v-model="newMessage.message" class="input-contact col-12 col-md-12" type="text" placeholder="Your Message" style="height:120px;padding-top:10px;"></textarea>

        <!--
        <input v-model="newMessage.company" class="input input-contact" type="text" placeholder="Your Company">
        <textarea v-model="newMessage.message" class="input input-contact" type="text" style="height:120px;" placeholder="Your Message"></textarea>
        --> 
  
        
          <div class="col-6 col-md-12">
            <button type="submit" v-on:click="show_contact_form=false;show_contact_form_web=false;" class="button-send-message">Send</button>
          </div>
        </div>
          
          
      
    </div>
  </form>
</transition>

    <div v-on:click='show_contact_form = !show_contact_form;' class="send-message-footer hidden-md">
      <img v-if="!show_contact_form" :src="images.send_message_button" style="width:63px">
      <img class="hidden-xs" transition="fadeLeft" v-else :src="images.send_message_cross" style="width:63px">
    </div>

    <div v-on:click='show_contact_form_web = !show_contact_form_web;' class="send-message-footer hidden-xs">
      
      <img v-if="!show_contact_form_web" :src="images.send_message_button" style="width:63px">     
      <img class="hidden-xs" transition="fadeLeft" v-else :src="images.send_message_cross" style="width:63px">

    </div>

  </div>
  
</template>

<script>
/* Import database variable from firebase.js */
import {db} from './firebase';
import toastr from 'toastr'

export default {
      data() {
        return {
            newMessage: {
                name: '',
                email: '',
                company: '',
                message:''
            },
            form: {
                name:'',
                company:'',
                pitch:''

            },
            images: {
                website: require('./assets/img/home/website.svg'),
                app: require('./assets/img/home/app.svg'),
                api: require('./assets/img/home/api.svg'),
                design: require('./assets/img/home/design.svg'),
                scroll: require('./assets/img/home/scroll.svg'),
                scroll_grey: require('./assets/img/home/scroll_grey.svg'),
                scroll_grey_open: require('./assets/img/home/scroll_grey_open.svg'),
                triangle: require('./assets/img/home/triangle.svg'),
                map: require('./assets/img/home/map.svg'),
                tick_white: require('./assets/img/price/tick_white.svg'),
                logo: require('./assets/img/home/trefle.svg'),
                logo_sidenav:require('./assets/img/home/logo_sidenav.svg'),
                solution:require('./assets/img/home/solution.svg'),
                discover:require('./assets/img/home/discover.svg'),
                price:require('./assets/img/home/price.svg'),
                french_flag: require('./assets/img/home/french_flag.svg'),
                fleche_droite: require('./assets/img/home/fleche_droite.svg'),
                send_message_button: require('./assets/img/home/send_message_button.svg'),
                send_message_cross: require('./assets/img/home/send_message_cross.svg'),

                logo_bottom: require('./assets/img/home/trefle_bottom.svg'),

                menu: require('./assets/img/home/menu.svg'),
                menu_bottom: require('./assets/img/home/menu_bottom.svg'),
                close: require('./assets/img/home/cross.svg'),

                contact_footer: require('./assets/img/footer/contact_footer.svg'),
                contact_footer_off: require('./assets/img/footer/contact_footer.1.svg'),
                process_footer: require('./assets/img/footer/process_footer.svg'),
                process_footer_off: require('./assets/img/footer/process_footer.1.svg'),
                home_footer: require('./assets/img/footer/home_footer.svg'),
                home_footer_off: require('./assets/img/footer/home_footer.1.svg'),

                isActive: false,
                regularFill: 'BLUE',
                activeFill: 'GREEN',
                svgFilepath: './src/assets/img/home/menu.svg',
                svgWidth: 200 + 'px',
                svgHeight: 200 + 'px',
                svgId: 'mySVG',
                buttonLabel: 'Click me to toggle'

                
            },
            show_menu_solution: false,
            show_menu_company: false,
            show_menu_solution_mobile:false,
            show_sidenav:false,
            show_logo_white:true,
            show_contact_form:false, 
            show_contact_form_web:false,   
            show_solutions:false,     
        }
    },
    firebase: {
      books: {
        source: db.ref('books'),
        cancelCallback(err) {
          console.error(err);
        }
      }
    },
    methods: {
      close_menu_header: function close_menu_header() {
            show_menu_solution: false;
            show_menu_company: false;
      },
      openContact: function openContact() {
        this.$data.show_contact_form=!this.$data.show_contact_form;
      },
      openContactWeb: function openContactWeb() {
        this.$data.show_contact_form_web=!this.$data.show_contact_form_web;
      },
      retract_main: function retract_main() {
        var header_top = document.getElementById("main");
        header_top.style.left = "200px";
      },
      bigger_main: function bigger_main() {
        var header_top = document.getElementById("main");
        header_top.style.left = "0px";

      },
      onScroll: function onScroll () {
          if (this.$route.name === 'home'){
            var div = document.getElementById("landing-3");
            var rect = div.getBoundingClientRect();

            var title_homepage = document.getElementById("title-homepage");
            var rect_title_homepage = title_homepage.getBoundingClientRect();
            //console.log("Coordinates: " + rect.left + "px, " + rect.top + "px");
            if (rect_title_homepage.top<70){
                var header_top = document.getElementById("header_top");
                header_top.style.border = "solid 1px #D5D3D3";
                header_top.style.backgroundColor = "white";
                header_top.style.color= "#232F43";
                this.$data.show_logo_white=false; 
                //console.log(rect_title_homepage.top); 
            }
            if (rect_title_homepage.top>70){
              //var header_top = document.getElementById("header_top");
              //header_top.style.backgroundColor = "transparent";
              //this.$data.show_logo_white=true; 
              //console.log('yooooo'); 
            }
          }
      },
      addMessage: function () {
        db.ref('messages').push(this.newMessage);
        toastr.success('Message sent');
        this.newMessage.name = '';
        this.newMessage.email = '';
        this.newMessage.company = '';
        this.newMessage.message = '';
      },
    },
    created () {
    window.addEventListener('scroll', this.onScroll);
    },
  }


function changeCss () {
  var y = window.scrollY;
  if (y<20){

    var header = document.getElementsByClassName("header")[0];
    //header.id = "header-scroll-top";
  }
  else{
    //var header = document.getElementsByClassName("header")[0];
    //var button_contact = document.getElementsByClassName("button-contact-menu")[0];

    //var button_menu = document.getElementsByClassName("svg-button")[0];

    //header.id = "header-scroll";
    //button_contact.id = "button-contact-menu-scroll";
    //document.getElementById("button-menu-bottom").style.display = "none";
    //document.getElementById("button-menu-top").style.display = "initial";

    //document.getElementById("logo-bottom").style.display = "none";
    //document.getElementById("logo-top").style.display = "initial";

  }

}
function set_menu_initial () {

    document.getElementById("button-menu-bottom").style.display = "initial";
    document.getElementById("button-menu-top").style.display = "none";

    document.getElementById("logo-bottom").style.display = "initial";
    document.getElementById("logo-top").style.display = "none";
}

//window.addEventListener("scroll", changeCss , false);

//window.addEventListener('load', set_menu_initial, false);


</script>

<style>

.link-ligne-sidenav-solution{
  height: 50px;
  color:white;
  font-size:16px;
  padding-top:13px;
 text-decoration:none; 
border-top: 1px solid transparent;
}

.link-ligne-sidenav{
  height: 50px;
  color:white;
  font-size:16px;
  padding-top:13px;
 text-decoration:none; 
/* Rectangle 29: */
border-top: 1px solid transparent;
}
.link-ligne-sidenav:focus{
  color:white;
 text-decoration:none; 
  background-color:rgb(236, 97, 5);
}
.link-ligne-sidenav:hover{
  color:white;
 text-decoration:none; 
}

.link-ligne-sidenav:active{
  color: white;
 text-decoration:none; 
}

.link-ligne-sidenav-solution-2{
  height: 50px;
  color:white;
  font-size:16px;
  padding-top:13px;
 text-decoration:none; 
}
.link-ligne-sidenav-solution-2:focus{
  color:white;
 text-decoration:none; 
  background-color:rgb(236, 97, 5);
}
.link-ligne-sidenav-solution-2:hover{
  color:white;
 text-decoration:none; 
}

.link-ligne-sidenav-solution-2:active{
  color: white;
 text-decoration:none; 
}



.link-ligne-sidenav-active{
  height: 50px;
  color:white;
  font-size:16px;
  padding-top:13px;
 text-decoration:none; 
 background-color:rgb(5, 182, 236);
border-top: 1px solid transparent;
}
.link-ligne-sidenav-active:focus{
  color: white;
 text-decoration:none; 
  background-color:rgb(236, 97, 5);
}

.link-ligne-sidenav-active:active{
  color: white;
 text-decoration:none; 
}

.link-ligne-sidenav-active-solution{
  height: 50px;
  color:white;
  font-size:16px;
  padding-top:13px;
 text-decoration:none; 
 background-color:rgb(236, 97, 5);

}
.link-ligne-sidenav-active-solution:focus{
  color: white;
 text-decoration:none; 
  background-color:rgb(236, 97, 5);
}

.link-ligne-sidenav-active-solution:active{
  color: white;
 text-decoration:none; 
}

.button-discover-company{
  margin-top:15px;
  padding-top:7px;
  font-size:15px;
background-image: linear-gradient(-180deg, #32ACDD 0%, #157CBF 100%);
  height: 40px;
  border-radius:4px;
  color: inherit;
 text-decoration:none; 
}

.button-discover-company:hover{
/* Rectangle 6: */
background-image: linear-gradient(-180deg, #5DC2EB 0%, #3391CF 100%);
  color: inherit;
 text-decoration:none; 
}

.button-discover-company:focus{
  color: inherit;
 text-decoration:none; 
}

.button-discover-company:active{
  color: inherit;
 text-decoration:none; 
}

.link-menu-deroulant{
  width:100%;
  height:35px;
  margin-left:0px;
  padding-top:5px;
  margin-top:5px;
  text-align:center;
  border: 1px solid transparent;
  border-radius:4px;
 color: inherit;
 text-decoration:none;
}
.link-menu-deroulant:hover{
  cursor: pointer;
  border: 1px solid white;
 color: inherit;
 text-decoration:none;
}

.link-menu-deroulant:focus{
 color: inherit;
 text-decoration:none;
}

.link-menu-company{
  width:100%;
  height:35px;
  margin-left:0px;
  padding-top:5px;
  margin-top:5px;
  text-align:left;
  border: 1px solid transparent;
  border-radius:4px;
 color: inherit;
 text-decoration:none;
}

.button-send-message{
  background-color:rgb(38, 168, 45);
  border: 1px solid white;
  margin:10px;
  width:100px;
  border-radius:4px;
  height:35px;
  color:white;
  font-weight:normal;
}


.button-send-message-cancel{
  background-color:rgb(235, 83, 45);
  margin:10px;
  width:100px;
  border: 1px solid white;
  padding-top:3px;
  border-radius:4px;
  height:35px;
  color:white;
  font-weight:normal;
}

.button-send-message-cancel:active{
  background-color:rgb(221, 117, 90);
}

.button-send-message:hover{
  background-color:#FDD187;
  cursor: pointer;  
}

.button-send-message:active{
  background-color:rgb(63, 236, 92);
  cursor: pointer;  
}


.input-contact{
  width: 100%;
  height:40px;
  border-width: 1px;
  border-style: solid;
  border-color:white;
  border-color:#509AF8; 
  margin-top:10px;
  border-radius:4px; 
  font-family: Avenir Next, sans-serif;
  color:#194C6E;
}
.input-contact:focus{
  border-color:rgb(26, 79, 194);    
}





.send-message-footer{
  position: fixed;
  bottom:18px;
  right: 18px;
  z-index:12;
  cursor: pointer;
}


.menu-solution{
/* Rectangle 16: */
background: rgba(35,47,67,0.97);
  border-radius:5px;
  font-size:14px;
  height:255px;
  padding-top:20px;
  margin-top:20px;
  color:white;
}

.menu-company{
/* Rectangle 16: */
background: rgba(35,47,67,0.97);
  border-radius:5px;
  font-size:14px;
  height:260px;
  padding-top:20px;
  margin-top:20px;
  color:white;
}

#button-menu-bottom{

}
#button-menu-top{
  display:initial;
  z-index:15;
  position:relative
}

.svg-button {
  position:relative;
}


.link-side-nav{
  margin:30px;
  border: 1px solid transparent;
 color: white;
 text-decoration:none;
 text-align:center;
 height:35px;
}

.link-side-nav:hover{
  border: 1px solid grey;
  border-radius:10px;
 color: white;
 text-decoration:none;
}

.menu-logo{
  padding-top:10px;
  text-align:center;
}

/* mobile screen */
@media only screen and (max-width:70em) { 
.hidden-xs{
  display:none;
}
.titre-logo{
  padding-left:0px;
  padding-top:7px;

}
.link-header-2{
font-family: Avenir Next, sans-serif;
-webkit-font-smoothing: antialiased;
font-weight:bold;
font-size:23px;
padding-top:9px;
 color: inherit;
 text-decoration:none;
 text-align:left;
}

.link-header-2:hover{
   color: inherit;
    text-decoration:none;
}
.link-header-2:active{
   color: inherit;
    text-decoration:none;
}

.contenu{
  width:100vw;
top:0;
margin:0;
margin-bottom:450px;
left:0px;
position:relative;
z-index:3;
}
.footer{
  position: fixed;
  width:100vw;
  z-index:2;
  bottom:0;
  height: 450px;
  background-color: #232F43;
  text-align: center;
font-family: Avenir Next, sans-serif;
color:white;
text-align:center;
}
.titre-colone-footer{
  color:#BCBABA;
  padding-top:20px;
}
.titre-logo-footer{
  color:#639EFB;
  padding-top:13px;
  font-size:15px;
  font-weight:bold;
}
.all-right-footer{
  padding-top:19px;
  font-size:10px;
  padding-right:70px;
  font-weight:bold;
}
.logo-footer{
  margin-left:20px;
}
.blue-form-contact{
 /* 9: */
background: #1565C0;
  border: 1px solid #FFFFFF;margin:3px;border-radius:3px;
}
.ligne-contact-form{
  width:98%;margin-left:0px;height:100vh;position:absolute;top:0px;z-index:13;
  text-align:center;
}
.title-contact-form{
  font-family: Avenir Next, sans-serif;
-webkit-font-smoothing: antialiased;
color:white;
font-size:24px;
font-weight:normal;
text-align:left;
margin:8px;
padding-top:10px;
}
}

/* big screen */
@media only screen and (min-width:70em) { 
.hidden-md{
  display:none;
}
.titre-logo{
  padding-left:0px;
  padding-top:9px;
  margin-left:140px;
}
.link-header-2{
font-family: Avenir Next, sans-serif;
-webkit-font-smoothing: antialiased;
font-weight:bold;
font-size:23px;
padding-top:9px;
padding-left:0px;
 color: inherit;
 text-decoration:none;
 text-align:center;
}

.link-header-2:hover{
   color: inherit;
    text-decoration:none;
}

.link-header-2:focus{
   color: inherit;
    text-decoration:none;
}
.link-header:focus{
   color: inherit;
    text-decoration:none;
}

.contenu{
width:100vw;
top:0;
margin:0;
margin-bottom:300px;
left:0;
position:relative;
z-index:3;
}
.footer{
  position: fixed;
  width:100vw;
  z-index:2;
  bottom:0;
  height: 300px;
  background-color: #232F43;
  text-align: center;
font-family: Avenir Next, sans-serif;
color:white;
text-align:center;
}
.titre-colone-footer{
  color:#BCBABA;
  margin-bottom:30px;
}
.titre-logo-footer{
  color:#639EFB;
  padding-top:10px;
  margin-left:60px;
  font-size:15px;
  font-weight:bold;
}
.all-right-footer{
  padding-top:16px;
  font-size:10px;
  padding-right:340px;
  font-weight:bold;
}
.blue-form-contact{
/* 9: */
background: #1565C0;
  border: 1px solid #FFFFFF;border-radius:3px;

}
.ligne-contact-form{
  width:99%;margin-left:0px;height:437px;position:fixed;bottom:90px;z-index:12;
    text-align:center;
}
.title-contact-form{
  font-family: Avenir Next, sans-serif;
-webkit-font-smoothing: antialiased;
color:white;
font-size:22px;
font-weight:normal;
text-align:left;
margin:8px;
}
}

.button-menu{
  background-color:transparent;
  border-style: none;
  text-decoration: none !important;
  padding-top:7px;
  width:100vw;
  text-align:center;
  cursor: pointer;
}
.button-close{
  background-color:transparent;
  border-style: none;
  text-decoration: none !important;
  padding-left:83%;
  padding-top:17px;
  cursor: pointer;
}
.logo-mobile{
  text-align:center;
  padding-top:4px;
}
.button-menu:focus,.button-menu:active, .button-close:focus,.button-close:active{
   outline: none;
}
.img-menu{
  width:30px;
}
#main{

    transition: 0.15s; /* 0.5 second transition effect to slide in the sidenav */
}

/* The side navigation menu */
.sidenav{
    height:100vh; /* 100% Full-height */
    width: 70vw; /* 0 width - change this with JavaScript */
    position: fixed; /* Stay in place */
    z-index: 10; /* Stay on top */
    left: 0;
/* 123 Night Sky: */
background-image: linear-gradient(0deg, #1E3C72 0%, #2A5298 100%);
box-shadow: 0 2px 6px 0 rgba(33,33,33,0.66);
  /*  border: 1px solid #D5D3D3;*/
    overflow-x: hidden; /* Disable horizontal scroll */
    transition: 0.15s; /* 0.5 second transition effect to slide in the sidenav */
    overflow-y: scroll;
    top:0;

}



/* Position and style the close button (top right corner) */
.sidenav .closebtn {
    position: absolute;
    top: 0;
    right: 25px;
    font-size: 36px;
    margin-left: 50px;
}

.header{
position:fixed;
width:100vw;
top:0;
margin:0;
left:0;
z-index:10;
height:60px;
color:white;
    text-decoration:none;
}



.header-fixe{
position:fixed;
width:100vw;
top:0;
margin:0;
left:0;
z-index:10;
height:60px;
color:#232F43;
background-color:white;
border:solid 1px #D5D3D3;
}

.footer-fixed{
position:fixed;
width:100vw;
bottom:0;
margin:0;
left:0;
z-index:10;
height:50px;
color:white;
text-decoration:none;
background-color:white;
border: 1px solid rgb(216, 214, 214);
}

.button-footer-fixed{
  height:50px;
  width:100vw;
  font-size:11px;
  padding-top:2px;
  color:#C0C0C0;
    cursor: pointer;
 text-decoration:none;
 text-align:center;
}
.img-button-footer{
  width:50px;
  padding-top:10px;

}

.contenu-header{
margin:6px;
width:100vw;
}

.link-header{
font-family: Avenir Next, sans-serif;
-webkit-font-smoothing: antialiased;
font-weight:bold;
font-size:13px;
padding-top:6px;
 color: inherit;
 text-decoration:none;
 text-align:center;
 cursor: pointer;
}

.link-header:hover{
   color: inherit;
    text-decoration:none;
}


.link-header:active{
   color: inherit;
    text-decoration:none;
}

.div-button-contact-menu{
  color: inherit;
 text-decoration:none;
 padding-top:8px;
 font-size:12px;
font-family: Avenir Next, sans-serif;
-webkit-font-smoothing: antialiased;
font-weight:bold;
 text-align:center;
}

.div-button-contact-menu:hover{
  color: inherit;
 text-decoration:none;
}

#button-contact-menu-scroll-top{

  margin-right:6px;
  width:90%;
  height:30px;
  border-radius:5px;
  font-weight:bold;
  background-color:#103D68;
  color:white;
}
#button-contact-menu-scroll-top:hover{
  background-color:#90C1F8;
  cursor: pointer;
}

#button-contact-menu-scroll{

  margin-right:6px;
  width:90%;
  height:40px;
  padding-top:8px;
  border-radius:5px;
  background-color:#63A8F7;
  color:white;
}

#header-scroll{
background-color:white;
/* Rectangle 10: 
box-shadow: 0 2px 21px 3px rgba(0,0,0,0.08);*/
color:#232F43;
border: 1px solid #ECE8E8;
}

#header-scroll-top{
background-color:transparent;
color:white;

}



#stars {
  width: 1px;
  height: 1px;
  background: transparent;
  box-shadow: 1316px 395px #FFF , 1736px 334px #FFF , 426px 591px #FFF , 375px 1396px #FFF , 1781px 1782px #FFF , 369px 1595px #FFF , 802px 1294px #FFF , 727px 1196px #FFF , 1488px 1373px #FFF , 1678px 784px #FFF , 1411px 753px #FFF , 192px 191px #FFF , 1190px 588px #FFF , 1469px 735px #FFF , 1482px 1278px #FFF , 1028px 1198px #FFF , 1034px 1688px #FFF , 684px 1480px #FFF , 829px 1537px #FFF , 1341px 280px #FFF , 1472px 1906px #FFF , 1376px 625px #FFF , 767px 1740px #FFF , 36px 793px #FFF , 329px 742px #FFF , 331px 126px #FFF , 1827px 505px #FFF , 951px 871px #FFF , 1438px 755px #FFF , 1581px 1298px #FFF , 522px 1753px #FFF , 1906px 1014px #FFF , 1681px 987px #FFF , 1848px 798px #FFF , 899px 692px #FFF , 1780px 121px #FFF , 341px 1602px #FFF , 1958px 1952px #FFF , 732px 1272px #FFF , 1813px 1157px #FFF , 85px 998px #FFF , 1892px 1338px #FFF , 1266px 645px #FFF , 462px 609px #FFF , 1185px 1216px #FFF , 598px 1238px #FFF , 1390px 505px #FFF , 620px 375px #FFF , 1406px 1026px #FFF , 97px 298px #FFF , 60px 1969px #FFF , 726px 1200px #FFF , 161px 1819px #FFF , 1404px 1912px #FFF , 225px 662px #FFF , 1557px 166px #FFF , 923px 1210px #FFF , 1836px 1481px #FFF , 1035px 1422px #FFF , 341px 1087px #FFF , 1836px 1762px #FFF , 869px 176px #FFF , 406px 1176px #FFF , 1146px 1128px #FFF , 315px 433px #FFF , 183px 1505px #FFF , 1223px 1627px #FFF , 278px 1271px #FFF , 383px 99px #FFF , 637px 1280px #FFF , 336px 457px #FFF , 249px 1530px #FFF , 281px 1723px #FFF , 685px 1933px #FFF , 1728px 1987px #FFF , 814px 1006px #FFF , 1380px 665px #FFF , 90px 907px #FFF , 866px 1483px #FFF , 1683px 1164px #FFF , 1605px 439px #FFF , 1194px 253px #FFF , 72px 1953px #FFF , 673px 1505px #FFF , 1840px 1437px #FFF , 1410px 1379px #FFF , 975px 1524px #FFF , 270px 521px #FFF , 1988px 1082px #FFF , 855px 1549px #FFF , 749px 207px #FFF , 448px 134px #FFF , 1372px 1425px #FFF , 1294px 355px #FFF , 1381px 1671px #FFF , 1795px 762px #FFF , 282px 1607px #FFF , 1903px 977px #FFF , 436px 1816px #FFF , 1991px 1067px #FFF , 1089px 428px #FFF , 399px 1835px #FFF , 1567px 716px #FFF , 1361px 1493px #FFF , 1226px 1603px #FFF , 1354px 587px #FFF , 1542px 635px #FFF , 1588px 865px #FFF , 657px 221px #FFF , 1799px 405px #FFF , 273px 25px #FFF , 89px 1948px #FFF , 1555px 1566px #FFF , 1088px 1128px #FFF , 764px 1817px #FFF , 697px 798px #FFF , 1077px 1305px #FFF , 624px 838px #FFF , 222px 1470px #FFF , 1175px 1695px #FFF , 1033px 895px #FFF , 91px 1476px #FFF , 591px 1503px #FFF , 1477px 1118px #FFF , 1093px 993px #FFF , 801px 873px #FFF , 1164px 1262px #FFF , 397px 1458px #FFF , 173px 972px #FFF , 1961px 557px #FFF , 1023px 1449px #FFF , 507px 811px #FFF , 1210px 1635px #FFF , 1861px 372px #FFF , 996px 352px #FFF , 1319px 1282px #FFF , 295px 144px #FFF , 1569px 462px #FFF , 811px 451px #FFF , 1429px 1382px #FFF , 778px 1130px #FFF , 405px 617px #FFF , 1083px 140px #FFF , 869px 1625px #FFF , 474px 56px #FFF , 27px 945px #FFF , 897px 1120px #FFF , 702px 738px #FFF , 871px 1317px #FFF , 1589px 1354px #FFF , 1167px 1584px #FFF , 1971px 335px #FFF , 247px 330px #FFF , 481px 1498px #FFF , 1973px 1117px #FFF , 1254px 53px #FFF , 1568px 216px #FFF , 563px 1969px #FFF , 1795px 1078px #FFF , 1042px 560px #FFF , 1942px 1371px #FFF , 499px 1906px #FFF , 636px 1694px #FFF , 564px 1018px #FFF , 1828px 1209px #FFF , 779px 337px #FFF , 7px 139px #FFF , 1729px 1641px #FFF , 1351px 1921px #FFF , 931px 1270px #FFF , 1700px 544px #FFF , 1020px 771px #FFF , 1391px 221px #FFF , 271px 912px #FFF , 15px 1607px #FFF , 600px 274px #FFF , 1615px 442px #FFF , 64px 769px #FFF , 399px 470px #FFF , 1826px 1160px #FFF , 1265px 1299px #FFF , 79px 693px #FFF , 1036px 290px #FFF , 1711px 179px #FFF , 58px 375px #FFF , 444px 686px #FFF , 1455px 507px #FFF , 1423px 462px #FFF , 668px 1537px #FFF , 1895px 1161px #FFF , 587px 1699px #FFF , 1385px 289px #FFF , 898px 760px #FFF , 797px 1869px #FFF , 258px 1749px #FFF , 1231px 1288px #FFF , 458px 71px #FFF , 357px 1904px #FFF , 638px 1477px #FFF , 12px 993px #FFF , 357px 75px #FFF , 1270px 1974px #FFF , 741px 739px #FFF , 1767px 1420px #FFF , 722px 952px #FFF , 1518px 1948px #FFF , 1266px 373px #FFF , 1460px 1035px #FFF , 80px 991px #FFF , 1939px 1572px #FFF , 764px 1486px #FFF , 1859px 1383px #FFF , 1764px 1598px #FFF , 1382px 1156px #FFF , 1685px 887px #FFF , 1895px 1350px #FFF , 438px 1543px #FFF , 911px 882px #FFF , 660px 1335px #FFF , 350px 1482px #FFF , 61px 1px #FFF , 1934px 394px #FFF , 318px 1886px #FFF , 1401px 1723px #FFF , 418px 458px #FFF , 1699px 13px #FFF , 1521px 1984px #FFF , 644px 1961px #FFF , 1759px 937px #FFF , 898px 865px #FFF , 1052px 499px #FFF , 896px 1610px #FFF , 656px 742px #FFF , 1336px 72px #FFF , 1143px 1692px #FFF , 642px 644px #FFF , 65px 714px #FFF , 407px 106px #FFF , 1106px 1943px #FFF , 413px 1537px #FFF , 1303px 515px #FFF , 974px 1012px #FFF , 865px 1084px #FFF , 154px 577px #FFF , 1373px 633px #FFF , 1379px 573px #FFF , 402px 1481px #FFF , 857px 1940px #FFF , 884px 145px #FFF , 272px 1860px #FFF , 1693px 1231px #FFF , 1165px 1896px #FFF , 746px 1186px #FFF , 1754px 1525px #FFF , 171px 130px #FFF , 761px 346px #FFF , 921px 67px #FFF , 727px 1168px #FFF , 1654px 1288px #FFF , 1225px 1598px #FFF , 144px 1391px #FFF , 853px 875px #FFF , 1160px 352px #FFF , 267px 291px #FFF , 640px 1049px #FFF , 690px 201px #FFF , 262px 1296px #FFF , 1141px 1525px #FFF , 1553px 429px #FFF , 1494px 703px #FFF , 144px 1567px #FFF , 1216px 830px #FFF , 516px 1254px #FFF , 1848px 397px #FFF , 295px 421px #FFF , 65px 1743px #FFF , 1627px 1463px #FFF , 1697px 1553px #FFF , 1316px 1802px #FFF , 242px 77px #FFF , 492px 1074px #FFF , 1352px 792px #FFF , 404px 1294px #FFF , 517px 1458px #FFF , 1947px 1934px #FFF , 412px 1516px #FFF , 1478px 1064px #FFF , 1297px 537px #FFF , 346px 1613px #FFF , 180px 814px #FFF , 369px 1319px #FFF , 1487px 841px #FFF , 550px 1097px #FFF , 1274px 282px #FFF , 1970px 1573px #FFF , 615px 267px #FFF , 1381px 240px #FFF , 78px 177px #FFF , 406px 1578px #FFF , 491px 1673px #FFF , 1862px 1112px #FFF , 215px 477px #FFF , 1632px 821px #FFF , 1822px 950px #FFF , 803px 472px #FFF , 390px 1648px #FFF , 1422px 568px #FFF , 503px 505px #FFF , 116px 7px #FFF , 1710px 1752px #FFF , 903px 1941px #FFF , 974px 1606px #FFF , 1462px 1922px #FFF , 410px 948px #FFF , 952px 1688px #FFF , 915px 1852px #FFF , 1934px 620px #FFF , 1282px 1363px #FFF , 1436px 1878px #FFF , 850px 1471px #FFF , 1464px 1785px #FFF , 1334px 351px #FFF , 90px 302px #FFF , 235px 225px #FFF , 97px 1331px #FFF , 131px 1183px #FFF , 573px 565px #FFF , 1693px 249px #FFF , 818px 625px #FFF , 1300px 1698px #FFF , 331px 653px #FFF , 370px 742px #FFF , 51px 101px #FFF , 229px 1531px #FFF , 1985px 1071px #FFF , 1962px 751px #FFF , 26px 345px #FFF , 1159px 768px #FFF , 1008px 1119px #FFF , 1810px 373px #FFF , 1571px 597px #FFF , 1477px 473px #FFF , 522px 534px #FFF , 1187px 291px #FFF , 1773px 646px #FFF , 545px 726px #FFF , 419px 182px #FFF , 1660px 391px #FFF , 513px 1464px #FFF , 604px 1668px #FFF , 299px 341px #FFF , 949px 443px #FFF , 1741px 550px #FFF , 923px 46px #FFF , 1889px 1980px #FFF , 1311px 634px #FFF , 700px 903px #FFF , 1585px 1378px #FFF , 1494px 668px #FFF , 434px 140px #FFF , 1003px 1240px #FFF , 786px 127px #FFF , 1954px 193px #FFF , 166px 731px #FFF , 1876px 1350px #FFF , 826px 1219px #FFF , 438px 597px #FFF , 377px 1780px #FFF , 31px 614px #FFF , 1389px 999px #FFF , 1256px 1685px #FFF , 765px 1946px #FFF , 238px 434px #FFF , 1148px 24px #FFF , 791px 1947px #FFF , 634px 937px #FFF , 456px 412px #FFF , 785px 851px #FFF , 332px 1322px #FFF , 1482px 1876px #FFF , 1461px 1255px #FFF , 279px 554px #FFF , 1693px 1448px #FFF , 1869px 1852px #FFF , 1540px 520px #FFF , 1723px 829px #FFF , 1289px 833px #FFF , 324px 284px #FFF , 65px 1322px #FFF , 760px 1574px #FFF , 1083px 385px #FFF , 943px 1643px #FFF , 452px 1937px #FFF , 322px 731px #FFF , 328px 759px #FFF , 1927px 1326px #FFF , 101px 1161px #FFF , 384px 738px #FFF , 9px 112px #FFF , 259px 361px #FFF , 680px 827px #FFF , 626px 1954px #FFF , 1685px 39px #FFF , 137px 1490px #FFF , 602px 476px #FFF , 1624px 1374px #FFF , 619px 744px #FFF , 1467px 1692px #FFF , 1117px 763px #FFF , 200px 1051px #FFF , 1720px 256px #FFF , 108px 996px #FFF , 104px 999px #FFF , 847px 111px #FFF , 1621px 939px #FFF , 160px 64px #FFF , 1380px 584px #FFF , 1023px 1046px #FFF , 688px 1696px #FFF , 221px 1802px #FFF , 1631px 1009px #FFF , 666px 1967px #FFF , 1597px 253px #FFF , 1162px 1292px #FFF , 763px 1224px #FFF , 736px 1672px #FFF , 1389px 1120px #FFF , 879px 1709px #FFF , 1670px 1585px #FFF , 395px 1758px #FFF , 426px 809px #FFF , 524px 125px #FFF , 1073px 1785px #FFF , 1858px 807px #FFF , 1146px 1829px #FFF , 1919px 866px #FFF , 789px 476px #FFF , 1933px 1525px #FFF , 1553px 1805px #FFF , 633px 1685px #FFF , 1472px 1005px #FFF , 1803px 592px #FFF , 1902px 251px #FFF , 1168px 1702px #FFF , 74px 1637px #FFF , 1899px 1130px #FFF , 1458px 1341px #FFF , 453px 671px #FFF , 1475px 735px #FFF , 1204px 1144px #FFF , 739px 908px #FFF , 1717px 664px #FFF , 1592px 1347px #FFF , 1812px 115px #FFF , 1885px 1734px #FFF , 1959px 923px #FFF , 418px 931px #FFF , 1612px 651px #FFF , 1231px 1874px #FFF , 920px 1715px #FFF , 1759px 1699px #FFF , 92px 1377px #FFF , 439px 1992px #FFF , 879px 1727px #FFF , 717px 918px #FFF , 1109px 1296px #FFF , 1351px 1482px #FFF , 798px 919px #FFF , 1004px 130px #FFF , 94px 716px #FFF , 1860px 1302px #FFF , 1452px 1498px #FFF , 1979px 861px #FFF , 1638px 871px #FFF , 986px 212px #FFF , 270px 869px #FFF , 1625px 1200px #FFF , 1447px 272px #FFF , 1905px 782px #FFF , 870px 325px #FFF , 697px 427px #FFF , 241px 326px #FFF , 1942px 382px #FFF , 1273px 390px #FFF , 1797px 1407px #FFF , 1820px 1215px #FFF , 1289px 845px #FFF , 885px 1350px #FFF , 907px 1930px #FFF , 1676px 1096px #FFF , 1942px 1277px #FFF , 1511px 848px #FFF , 765px 1214px #FFF , 650px 399px #FFF , 463px 94px #FFF , 1350px 1815px #FFF , 1391px 1449px #FFF , 358px 397px #FFF , 325px 1884px #FFF , 1701px 963px #FFF , 782px 1432px #FFF , 1321px 1252px #FFF , 678px 856px #FFF , 953px 1602px #FFF , 1776px 1488px #FFF , 1287px 1373px #FFF , 847px 314px #FFF , 1210px 1285px #FFF , 1370px 1689px #FFF , 171px 1004px #FFF , 1430px 530px #FFF , 1231px 837px #FFF , 1761px 1508px #FFF , 829px 5px #FFF , 249px 657px #FFF , 1953px 327px #FFF , 60px 496px #FFF , 725px 1505px #FFF , 1744px 911px #FFF , 1370px 1584px #FFF , 1612px 956px #FFF , 5px 1292px #FFF , 1323px 1350px #FFF , 895px 693px #FFF , 1538px 1530px #FFF , 1041px 553px #FFF , 1781px 997px #FFF , 1034px 183px #FFF , 1521px 829px #FFF , 446px 532px #FFF , 1882px 265px #FFF , 1564px 572px #FFF , 1615px 1964px #FFF , 702px 1086px #FFF , 1312px 1580px #FFF , 621px 1470px #FFF , 54px 216px #FFF , 908px 296px #FFF , 490px 1512px #FFF , 201px 450px #FFF , 1890px 1336px #FFF , 1468px 1387px #FFF , 899px 164px #FFF , 1559px 1692px #FFF , 921px 135px #FFF , 1185px 207px #FFF , 237px 360px #FFF , 1051px 1080px #FFF , 1254px 1643px #FFF , 921px 474px #FFF , 546px 1534px #FFF , 1948px 510px #FFF , 1165px 1472px #FFF , 1808px 1256px #FFF , 1350px 410px #FFF , 997px 1118px #FFF , 321px 240px #FFF , 169px 1291px #FFF , 837px 1205px #FFF , 813px 1219px #FFF , 244px 1476px #FFF , 160px 1166px #FFF , 62px 510px #FFF , 872px 1569px #FFF , 1095px 1387px #FFF , 237px 930px #FFF , 1885px 916px #FFF , 84px 1659px #FFF , 1323px 1432px #FFF , 417px 559px #FFF , 1730px 31px #FFF , 1600px 974px #FFF , 994px 1963px #FFF , 1169px 1940px #FFF , 1115px 1908px #FFF , 685px 1841px #FFF , 1542px 1402px #FFF , 2000px 1863px #FFF , 391px 160px #FFF , 900px 1002px #FFF , 425px 1429px #FFF , 1403px 712px #FFF , 764px 45px #FFF , 1884px 764px #FFF , 973px 1529px #FFF , 1186px 701px #FFF , 1314px 1204px #FFF , 736px 1960px #FFF , 488px 1508px #FFF , 861px 1128px #FFF , 1784px 1906px #FFF , 1634px 803px #FFF , 1027px 1842px #FFF , 1856px 1159px #FFF , 1358px 402px #FFF , 515px 971px #FFF , 775px 1692px #FFF , 1118px 691px #FFF , 372px 944px #FFF , 1267px 326px #FFF , 284px 1802px #FFF , 426px 1544px #FFF , 272px 1530px #FFF , 1885px 1355px #FFF , 1708px 564px #FFF , 529px 729px #FFF , 710px 1972px #FFF , 1830px 1957px #FFF , 241px 266px #FFF , 1570px 519px #FFF , 740px 242px #FFF , 1114px 191px #FFF , 373px 762px #FFF , 611px 1967px #FFF , 442px 1442px #FFF , 1478px 1026px #FFF , 1912px 1246px #FFF , 1129px 161px #FFF , 1071px 110px #FFF , 1952px 441px #FFF , 1608px 487px #FFF , 1233px 1762px #FFF , 1648px 1900px #FFF , 1230px 1565px #FFF , 432px 1636px #FFF , 555px 1591px #FFF , 257px 1116px #FFF , 896px 341px #FFF , 1378px 660px #FFF , 1073px 972px #FFF , 389px 287px #FFF , 1119px 1917px #FFF , 263px 434px #FFF , 809px 726px #FFF , 1890px 1812px #FFF , 1937px 1094px #FFF , 604px 95px #FFF , 1894px 129px #FFF , 1634px 414px #FFF , 1722px 329px #FFF , 783px 1722px #FFF , 1060px 1746px #FFF , 584px 1629px #FFF , 1215px 57px #FFF , 1297px 1733px #FFF , 1612px 1193px #FFF , 561px 1402px #FFF , 1313px 1453px #FFF , 786px 689px #FFF , 1461px 1544px #FFF , 1244px 1637px #FFF , 1755px 25px #FFF , 330px 307px #FFF , 789px 1298px #FFF , 656px 329px #FFF , 1632px 95px #FFF , 760px 1478px #FFF , 1370px 867px #FFF , 1360px 26px #FFF , 1333px 966px #FFF , 892px 483px #FFF , 390px 1729px #FFF , 1347px 154px #FFF , 1842px 87px #FFF , 99px 365px #FFF , 576px 331px #FFF , 26px 1019px #FFF , 421px 867px #FFF , 1566px 1138px #FFF , 73px 1835px #FFF , 1521px 1290px #FFF , 91px 742px #FFF , 1755px 1728px #FFF , 1787px 1398px #FFF , 788px 1121px #FFF , 1562px 719px #FFF , 412px 1548px #FFF , 538px 836px #FFF , 574px 379px #FFF , 1067px 718px #FFF , 965px 1591px #FFF , 666px 1872px #FFF , 525px 1212px #FFF , 1007px 1112px #FFF , 1407px 773px #FFF , 1386px 1780px #FFF , 1011px 650px #FFF , 611px 1776px #FFF , 403px 1561px #FFF , 1215px 1698px #FFF , 279px 302px #FFF , 1864px 129px #FFF , 1189px 417px #FFF , 1716px 1743px #FFF , 1984px 1371px #FFF , 108px 266px #FFF , 450px 640px #FFF , 1519px 42px #FFF , 1976px 638px #FFF , 1442px 365px #FFF;
  animation: animStar 50s linear infinite;
}
#stars:after {
  content: " ";
  position: absolute;
  top: 2000px;
  width: 1px;
  height: 1px;
  background: transparent;
  box-shadow: 1316px 395px #FFF , 1736px 334px #FFF , 426px 591px #FFF , 375px 1396px #FFF , 1781px 1782px #FFF , 369px 1595px #FFF , 802px 1294px #FFF , 727px 1196px #FFF , 1488px 1373px #FFF , 1678px 784px #FFF , 1411px 753px #FFF , 192px 191px #FFF , 1190px 588px #FFF , 1469px 735px #FFF , 1482px 1278px #FFF , 1028px 1198px #FFF , 1034px 1688px #FFF , 684px 1480px #FFF , 829px 1537px #FFF , 1341px 280px #FFF , 1472px 1906px #FFF , 1376px 625px #FFF , 767px 1740px #FFF , 36px 793px #FFF , 329px 742px #FFF , 331px 126px #FFF , 1827px 505px #FFF , 951px 871px #FFF , 1438px 755px #FFF , 1581px 1298px #FFF , 522px 1753px #FFF , 1906px 1014px #FFF , 1681px 987px #FFF , 1848px 798px #FFF , 899px 692px #FFF , 1780px 121px #FFF , 341px 1602px #FFF , 1958px 1952px #FFF , 732px 1272px #FFF , 1813px 1157px #FFF , 85px 998px #FFF , 1892px 1338px #FFF , 1266px 645px #FFF , 462px 609px #FFF , 1185px 1216px #FFF , 598px 1238px #FFF , 1390px 505px #FFF , 620px 375px #FFF , 1406px 1026px #FFF , 97px 298px #FFF , 60px 1969px #FFF , 726px 1200px #FFF , 161px 1819px #FFF , 1404px 1912px #FFF , 225px 662px #FFF , 1557px 166px #FFF , 923px 1210px #FFF , 1836px 1481px #FFF , 1035px 1422px #FFF , 341px 1087px #FFF , 1836px 1762px #FFF , 869px 176px #FFF , 406px 1176px #FFF , 1146px 1128px #FFF , 315px 433px #FFF , 183px 1505px #FFF , 1223px 1627px #FFF , 278px 1271px #FFF , 383px 99px #FFF , 637px 1280px #FFF , 336px 457px #FFF , 249px 1530px #FFF , 281px 1723px #FFF , 685px 1933px #FFF , 1728px 1987px #FFF , 814px 1006px #FFF , 1380px 665px #FFF , 90px 907px #FFF , 866px 1483px #FFF , 1683px 1164px #FFF , 1605px 439px #FFF , 1194px 253px #FFF , 72px 1953px #FFF , 673px 1505px #FFF , 1840px 1437px #FFF , 1410px 1379px #FFF , 975px 1524px #FFF , 270px 521px #FFF , 1988px 1082px #FFF , 855px 1549px #FFF , 749px 207px #FFF , 448px 134px #FFF , 1372px 1425px #FFF , 1294px 355px #FFF , 1381px 1671px #FFF , 1795px 762px #FFF , 282px 1607px #FFF , 1903px 977px #FFF , 436px 1816px #FFF , 1991px 1067px #FFF , 1089px 428px #FFF , 399px 1835px #FFF , 1567px 716px #FFF , 1361px 1493px #FFF , 1226px 1603px #FFF , 1354px 587px #FFF , 1542px 635px #FFF , 1588px 865px #FFF , 657px 221px #FFF , 1799px 405px #FFF , 273px 25px #FFF , 89px 1948px #FFF , 1555px 1566px #FFF , 1088px 1128px #FFF , 764px 1817px #FFF , 697px 798px #FFF , 1077px 1305px #FFF , 624px 838px #FFF , 222px 1470px #FFF , 1175px 1695px #FFF , 1033px 895px #FFF , 91px 1476px #FFF , 591px 1503px #FFF , 1477px 1118px #FFF , 1093px 993px #FFF , 801px 873px #FFF , 1164px 1262px #FFF , 397px 1458px #FFF , 173px 972px #FFF , 1961px 557px #FFF , 1023px 1449px #FFF , 507px 811px #FFF , 1210px 1635px #FFF , 1861px 372px #FFF , 996px 352px #FFF , 1319px 1282px #FFF , 295px 144px #FFF , 1569px 462px #FFF , 811px 451px #FFF , 1429px 1382px #FFF , 778px 1130px #FFF , 405px 617px #FFF , 1083px 140px #FFF , 869px 1625px #FFF , 474px 56px #FFF , 27px 945px #FFF , 897px 1120px #FFF , 702px 738px #FFF , 871px 1317px #FFF , 1589px 1354px #FFF , 1167px 1584px #FFF , 1971px 335px #FFF , 247px 330px #FFF , 481px 1498px #FFF , 1973px 1117px #FFF , 1254px 53px #FFF , 1568px 216px #FFF , 563px 1969px #FFF , 1795px 1078px #FFF , 1042px 560px #FFF , 1942px 1371px #FFF , 499px 1906px #FFF , 636px 1694px #FFF , 564px 1018px #FFF , 1828px 1209px #FFF , 779px 337px #FFF , 7px 139px #FFF , 1729px 1641px #FFF , 1351px 1921px #FFF , 931px 1270px #FFF , 1700px 544px #FFF , 1020px 771px #FFF , 1391px 221px #FFF , 271px 912px #FFF , 15px 1607px #FFF , 600px 274px #FFF , 1615px 442px #FFF , 64px 769px #FFF , 399px 470px #FFF , 1826px 1160px #FFF , 1265px 1299px #FFF , 79px 693px #FFF , 1036px 290px #FFF , 1711px 179px #FFF , 58px 375px #FFF , 444px 686px #FFF , 1455px 507px #FFF , 1423px 462px #FFF , 668px 1537px #FFF , 1895px 1161px #FFF , 587px 1699px #FFF , 1385px 289px #FFF , 898px 760px #FFF , 797px 1869px #FFF , 258px 1749px #FFF , 1231px 1288px #FFF , 458px 71px #FFF , 357px 1904px #FFF , 638px 1477px #FFF , 12px 993px #FFF , 357px 75px #FFF , 1270px 1974px #FFF , 741px 739px #FFF , 1767px 1420px #FFF , 722px 952px #FFF , 1518px 1948px #FFF , 1266px 373px #FFF , 1460px 1035px #FFF , 80px 991px #FFF , 1939px 1572px #FFF , 764px 1486px #FFF , 1859px 1383px #FFF , 1764px 1598px #FFF , 1382px 1156px #FFF , 1685px 887px #FFF , 1895px 1350px #FFF , 438px 1543px #FFF , 911px 882px #FFF , 660px 1335px #FFF , 350px 1482px #FFF , 61px 1px #FFF , 1934px 394px #FFF , 318px 1886px #FFF , 1401px 1723px #FFF , 418px 458px #FFF , 1699px 13px #FFF , 1521px 1984px #FFF , 644px 1961px #FFF , 1759px 937px #FFF , 898px 865px #FFF , 1052px 499px #FFF , 896px 1610px #FFF , 656px 742px #FFF , 1336px 72px #FFF , 1143px 1692px #FFF , 642px 644px #FFF , 65px 714px #FFF , 407px 106px #FFF , 1106px 1943px #FFF , 413px 1537px #FFF , 1303px 515px #FFF , 974px 1012px #FFF , 865px 1084px #FFF , 154px 577px #FFF , 1373px 633px #FFF , 1379px 573px #FFF , 402px 1481px #FFF , 857px 1940px #FFF , 884px 145px #FFF , 272px 1860px #FFF , 1693px 1231px #FFF , 1165px 1896px #FFF , 746px 1186px #FFF , 1754px 1525px #FFF , 171px 130px #FFF , 761px 346px #FFF , 921px 67px #FFF , 727px 1168px #FFF , 1654px 1288px #FFF , 1225px 1598px #FFF , 144px 1391px #FFF , 853px 875px #FFF , 1160px 352px #FFF , 267px 291px #FFF , 640px 1049px #FFF , 690px 201px #FFF , 262px 1296px #FFF , 1141px 1525px #FFF , 1553px 429px #FFF , 1494px 703px #FFF , 144px 1567px #FFF , 1216px 830px #FFF , 516px 1254px #FFF , 1848px 397px #FFF , 295px 421px #FFF , 65px 1743px #FFF , 1627px 1463px #FFF , 1697px 1553px #FFF , 1316px 1802px #FFF , 242px 77px #FFF , 492px 1074px #FFF , 1352px 792px #FFF , 404px 1294px #FFF , 517px 1458px #FFF , 1947px 1934px #FFF , 412px 1516px #FFF , 1478px 1064px #FFF , 1297px 537px #FFF , 346px 1613px #FFF , 180px 814px #FFF , 369px 1319px #FFF , 1487px 841px #FFF , 550px 1097px #FFF , 1274px 282px #FFF , 1970px 1573px #FFF , 615px 267px #FFF , 1381px 240px #FFF , 78px 177px #FFF , 406px 1578px #FFF , 491px 1673px #FFF , 1862px 1112px #FFF , 215px 477px #FFF , 1632px 821px #FFF , 1822px 950px #FFF , 803px 472px #FFF , 390px 1648px #FFF , 1422px 568px #FFF , 503px 505px #FFF , 116px 7px #FFF , 1710px 1752px #FFF , 903px 1941px #FFF , 974px 1606px #FFF , 1462px 1922px #FFF , 410px 948px #FFF , 952px 1688px #FFF , 915px 1852px #FFF , 1934px 620px #FFF , 1282px 1363px #FFF , 1436px 1878px #FFF , 850px 1471px #FFF , 1464px 1785px #FFF , 1334px 351px #FFF , 90px 302px #FFF , 235px 225px #FFF , 97px 1331px #FFF , 131px 1183px #FFF , 573px 565px #FFF , 1693px 249px #FFF , 818px 625px #FFF , 1300px 1698px #FFF , 331px 653px #FFF , 370px 742px #FFF , 51px 101px #FFF , 229px 1531px #FFF , 1985px 1071px #FFF , 1962px 751px #FFF , 26px 345px #FFF , 1159px 768px #FFF , 1008px 1119px #FFF , 1810px 373px #FFF , 1571px 597px #FFF , 1477px 473px #FFF , 522px 534px #FFF , 1187px 291px #FFF , 1773px 646px #FFF , 545px 726px #FFF , 419px 182px #FFF , 1660px 391px #FFF , 513px 1464px #FFF , 604px 1668px #FFF , 299px 341px #FFF , 949px 443px #FFF , 1741px 550px #FFF , 923px 46px #FFF , 1889px 1980px #FFF , 1311px 634px #FFF , 700px 903px #FFF , 1585px 1378px #FFF , 1494px 668px #FFF , 434px 140px #FFF , 1003px 1240px #FFF , 786px 127px #FFF , 1954px 193px #FFF , 166px 731px #FFF , 1876px 1350px #FFF , 826px 1219px #FFF , 438px 597px #FFF , 377px 1780px #FFF , 31px 614px #FFF , 1389px 999px #FFF , 1256px 1685px #FFF , 765px 1946px #FFF , 238px 434px #FFF , 1148px 24px #FFF , 791px 1947px #FFF , 634px 937px #FFF , 456px 412px #FFF , 785px 851px #FFF , 332px 1322px #FFF , 1482px 1876px #FFF , 1461px 1255px #FFF , 279px 554px #FFF , 1693px 1448px #FFF , 1869px 1852px #FFF , 1540px 520px #FFF , 1723px 829px #FFF , 1289px 833px #FFF , 324px 284px #FFF , 65px 1322px #FFF , 760px 1574px #FFF , 1083px 385px #FFF , 943px 1643px #FFF , 452px 1937px #FFF , 322px 731px #FFF , 328px 759px #FFF , 1927px 1326px #FFF , 101px 1161px #FFF , 384px 738px #FFF , 9px 112px #FFF , 259px 361px #FFF , 680px 827px #FFF , 626px 1954px #FFF , 1685px 39px #FFF , 137px 1490px #FFF , 602px 476px #FFF , 1624px 1374px #FFF , 619px 744px #FFF , 1467px 1692px #FFF , 1117px 763px #FFF , 200px 1051px #FFF , 1720px 256px #FFF , 108px 996px #FFF , 104px 999px #FFF , 847px 111px #FFF , 1621px 939px #FFF , 160px 64px #FFF , 1380px 584px #FFF , 1023px 1046px #FFF , 688px 1696px #FFF , 221px 1802px #FFF , 1631px 1009px #FFF , 666px 1967px #FFF , 1597px 253px #FFF , 1162px 1292px #FFF , 763px 1224px #FFF , 736px 1672px #FFF , 1389px 1120px #FFF , 879px 1709px #FFF , 1670px 1585px #FFF , 395px 1758px #FFF , 426px 809px #FFF , 524px 125px #FFF , 1073px 1785px #FFF , 1858px 807px #FFF , 1146px 1829px #FFF , 1919px 866px #FFF , 789px 476px #FFF , 1933px 1525px #FFF , 1553px 1805px #FFF , 633px 1685px #FFF , 1472px 1005px #FFF , 1803px 592px #FFF , 1902px 251px #FFF , 1168px 1702px #FFF , 74px 1637px #FFF , 1899px 1130px #FFF , 1458px 1341px #FFF , 453px 671px #FFF , 1475px 735px #FFF , 1204px 1144px #FFF , 739px 908px #FFF , 1717px 664px #FFF , 1592px 1347px #FFF , 1812px 115px #FFF , 1885px 1734px #FFF , 1959px 923px #FFF , 418px 931px #FFF , 1612px 651px #FFF , 1231px 1874px #FFF , 920px 1715px #FFF , 1759px 1699px #FFF , 92px 1377px #FFF , 439px 1992px #FFF , 879px 1727px #FFF , 717px 918px #FFF , 1109px 1296px #FFF , 1351px 1482px #FFF , 798px 919px #FFF , 1004px 130px #FFF , 94px 716px #FFF , 1860px 1302px #FFF , 1452px 1498px #FFF , 1979px 861px #FFF , 1638px 871px #FFF , 986px 212px #FFF , 270px 869px #FFF , 1625px 1200px #FFF , 1447px 272px #FFF , 1905px 782px #FFF , 870px 325px #FFF , 697px 427px #FFF , 241px 326px #FFF , 1942px 382px #FFF , 1273px 390px #FFF , 1797px 1407px #FFF , 1820px 1215px #FFF , 1289px 845px #FFF , 885px 1350px #FFF , 907px 1930px #FFF , 1676px 1096px #FFF , 1942px 1277px #FFF , 1511px 848px #FFF , 765px 1214px #FFF , 650px 399px #FFF , 463px 94px #FFF , 1350px 1815px #FFF , 1391px 1449px #FFF , 358px 397px #FFF , 325px 1884px #FFF , 1701px 963px #FFF , 782px 1432px #FFF , 1321px 1252px #FFF , 678px 856px #FFF , 953px 1602px #FFF , 1776px 1488px #FFF , 1287px 1373px #FFF , 847px 314px #FFF , 1210px 1285px #FFF , 1370px 1689px #FFF , 171px 1004px #FFF , 1430px 530px #FFF , 1231px 837px #FFF , 1761px 1508px #FFF , 829px 5px #FFF , 249px 657px #FFF , 1953px 327px #FFF , 60px 496px #FFF , 725px 1505px #FFF , 1744px 911px #FFF , 1370px 1584px #FFF , 1612px 956px #FFF , 5px 1292px #FFF , 1323px 1350px #FFF , 895px 693px #FFF , 1538px 1530px #FFF , 1041px 553px #FFF , 1781px 997px #FFF , 1034px 183px #FFF , 1521px 829px #FFF , 446px 532px #FFF , 1882px 265px #FFF , 1564px 572px #FFF , 1615px 1964px #FFF , 702px 1086px #FFF , 1312px 1580px #FFF , 621px 1470px #FFF , 54px 216px #FFF , 908px 296px #FFF , 490px 1512px #FFF , 201px 450px #FFF , 1890px 1336px #FFF , 1468px 1387px #FFF , 899px 164px #FFF , 1559px 1692px #FFF , 921px 135px #FFF , 1185px 207px #FFF , 237px 360px #FFF , 1051px 1080px #FFF , 1254px 1643px #FFF , 921px 474px #FFF , 546px 1534px #FFF , 1948px 510px #FFF , 1165px 1472px #FFF , 1808px 1256px #FFF , 1350px 410px #FFF , 997px 1118px #FFF , 321px 240px #FFF , 169px 1291px #FFF , 837px 1205px #FFF , 813px 1219px #FFF , 244px 1476px #FFF , 160px 1166px #FFF , 62px 510px #FFF , 872px 1569px #FFF , 1095px 1387px #FFF , 237px 930px #FFF , 1885px 916px #FFF , 84px 1659px #FFF , 1323px 1432px #FFF , 417px 559px #FFF , 1730px 31px #FFF , 1600px 974px #FFF , 994px 1963px #FFF , 1169px 1940px #FFF , 1115px 1908px #FFF , 685px 1841px #FFF , 1542px 1402px #FFF , 2000px 1863px #FFF , 391px 160px #FFF , 900px 1002px #FFF , 425px 1429px #FFF , 1403px 712px #FFF , 764px 45px #FFF , 1884px 764px #FFF , 973px 1529px #FFF , 1186px 701px #FFF , 1314px 1204px #FFF , 736px 1960px #FFF , 488px 1508px #FFF , 861px 1128px #FFF , 1784px 1906px #FFF , 1634px 803px #FFF , 1027px 1842px #FFF , 1856px 1159px #FFF , 1358px 402px #FFF , 515px 971px #FFF , 775px 1692px #FFF , 1118px 691px #FFF , 372px 944px #FFF , 1267px 326px #FFF , 284px 1802px #FFF , 426px 1544px #FFF , 272px 1530px #FFF , 1885px 1355px #FFF , 1708px 564px #FFF , 529px 729px #FFF , 710px 1972px #FFF , 1830px 1957px #FFF , 241px 266px #FFF , 1570px 519px #FFF , 740px 242px #FFF , 1114px 191px #FFF , 373px 762px #FFF , 611px 1967px #FFF , 442px 1442px #FFF , 1478px 1026px #FFF , 1912px 1246px #FFF , 1129px 161px #FFF , 1071px 110px #FFF , 1952px 441px #FFF , 1608px 487px #FFF , 1233px 1762px #FFF , 1648px 1900px #FFF , 1230px 1565px #FFF , 432px 1636px #FFF , 555px 1591px #FFF , 257px 1116px #FFF , 896px 341px #FFF , 1378px 660px #FFF , 1073px 972px #FFF , 389px 287px #FFF , 1119px 1917px #FFF , 263px 434px #FFF , 809px 726px #FFF , 1890px 1812px #FFF , 1937px 1094px #FFF , 604px 95px #FFF , 1894px 129px #FFF , 1634px 414px #FFF , 1722px 329px #FFF , 783px 1722px #FFF , 1060px 1746px #FFF , 584px 1629px #FFF , 1215px 57px #FFF , 1297px 1733px #FFF , 1612px 1193px #FFF , 561px 1402px #FFF , 1313px 1453px #FFF , 786px 689px #FFF , 1461px 1544px #FFF , 1244px 1637px #FFF , 1755px 25px #FFF , 330px 307px #FFF , 789px 1298px #FFF , 656px 329px #FFF , 1632px 95px #FFF , 760px 1478px #FFF , 1370px 867px #FFF , 1360px 26px #FFF , 1333px 966px #FFF , 892px 483px #FFF , 390px 1729px #FFF , 1347px 154px #FFF , 1842px 87px #FFF , 99px 365px #FFF , 576px 331px #FFF , 26px 1019px #FFF , 421px 867px #FFF , 1566px 1138px #FFF , 73px 1835px #FFF , 1521px 1290px #FFF , 91px 742px #FFF , 1755px 1728px #FFF , 1787px 1398px #FFF , 788px 1121px #FFF , 1562px 719px #FFF , 412px 1548px #FFF , 538px 836px #FFF , 574px 379px #FFF , 1067px 718px #FFF , 965px 1591px #FFF , 666px 1872px #FFF , 525px 1212px #FFF , 1007px 1112px #FFF , 1407px 773px #FFF , 1386px 1780px #FFF , 1011px 650px #FFF , 611px 1776px #FFF , 403px 1561px #FFF , 1215px 1698px #FFF , 279px 302px #FFF , 1864px 129px #FFF , 1189px 417px #FFF , 1716px 1743px #FFF , 1984px 1371px #FFF , 108px 266px #FFF , 450px 640px #FFF , 1519px 42px #FFF , 1976px 638px #FFF , 1442px 365px #FFF;
}

#stars2 {
  width: 2px;
  height: 2px;
  background: transparent;
  box-shadow: 1414px 1536px #FFF , 192px 1184px #FFF , 495px 10px #FFF , 838px 402px #FFF , 145px 509px #FFF , 1638px 428px #FFF , 102px 1790px #FFF , 1160px 1584px #FFF , 822px 1371px #FFF , 912px 1004px #FFF , 101px 1559px #FFF , 1746px 1540px #FFF , 783px 890px #FFF , 881px 1449px #FFF , 1801px 870px #FFF , 1418px 316px #FFF , 176px 1px #FFF , 979px 79px #FFF , 705px 651px #FFF , 957px 355px #FFF , 379px 1647px #FFF , 746px 1964px #FFF , 579px 486px #FFF , 293px 898px #FFF , 1807px 307px #FFF , 520px 1957px #FFF , 1003px 1855px #FFF , 1333px 1243px #FFF , 1708px 486px #FFF , 532px 717px #FFF , 989px 527px #FFF , 1419px 272px #FFF , 1061px 777px #FFF , 1914px 1822px #FFF , 1442px 989px #FFF , 181px 231px #FFF , 1879px 135px #FFF , 1335px 310px #FFF , 1902px 638px #FFF , 1744px 1085px #FFF , 1528px 814px #FFF , 1607px 173px #FFF , 1403px 155px #FFF , 12px 222px #FFF , 260px 1141px #FFF , 1659px 924px #FFF , 1104px 1637px #FFF , 110px 71px #FFF , 1361px 849px #FFF , 642px 1549px #FFF , 166px 1325px #FFF , 3px 1023px #FFF , 1212px 1179px #FFF , 1680px 1158px #FFF , 263px 1917px #FFF , 584px 181px #FFF , 683px 1837px #FFF , 1862px 1623px #FFF , 1960px 374px #FFF , 23px 407px #FFF , 395px 187px #FFF , 1299px 135px #FFF , 73px 1860px #FFF , 101px 947px #FFF , 1185px 954px #FFF , 136px 1331px #FFF , 240px 1903px #FFF , 156px 939px #FFF , 1068px 1658px #FFF , 1698px 63px #FFF , 468px 1992px #FFF , 1097px 1927px #FFF , 1716px 942px #FFF , 484px 598px #FFF , 301px 1607px #FFF , 1794px 482px #FFF , 1712px 404px #FFF , 655px 1522px #FFF , 363px 795px #FFF , 1114px 653px #FFF , 440px 210px #FFF , 66px 1739px #FFF , 1654px 362px #FFF , 526px 326px #FFF , 629px 1153px #FFF , 842px 1779px #FFF , 617px 1353px #FFF , 1633px 1929px #FFF , 76px 627px #FFF , 292px 607px #FFF , 390px 1753px #FFF , 411px 28px #FFF , 296px 555px #FFF , 390px 226px #FFF , 1984px 1566px #FFF , 1282px 518px #FFF , 665px 981px #FFF , 846px 1560px #FFF , 804px 984px #FFF , 1020px 1939px #FFF , 3px 1222px #FFF , 206px 1208px #FFF , 1623px 1246px #FFF , 734px 757px #FFF , 1320px 1110px #FFF , 498px 1354px #FFF , 973px 412px #FFF , 817px 503px #FFF , 46px 1682px #FFF , 1947px 843px #FFF , 1302px 619px #FFF , 674px 816px #FFF , 292px 758px #FFF , 295px 943px #FFF , 1594px 955px #FFF , 1003px 92px #FFF , 1065px 1984px #FFF , 409px 1501px #FFF , 996px 1354px #FFF , 1911px 1988px #FFF , 1069px 1353px #FFF , 1605px 1848px #FFF , 715px 738px #FFF , 456px 425px #FFF , 400px 543px #FFF , 854px 418px #FFF , 1284px 1219px #FFF , 870px 1707px #FFF , 529px 578px #FFF , 1550px 912px #FFF , 867px 540px #FFF , 355px 956px #FFF , 389px 1865px #FFF , 1137px 29px #FFF , 991px 746px #FFF , 799px 634px #FFF , 1835px 1888px #FFF , 1908px 1282px #FFF , 1151px 1041px #FFF , 1285px 1575px #FFF , 1696px 1080px #FFF , 91px 191px #FFF , 468px 674px #FFF , 598px 369px #FFF , 1695px 32px #FFF , 1485px 1655px #FFF , 188px 1511px #FFF , 255px 430px #FFF , 515px 784px #FFF , 777px 748px #FFF , 1714px 138px #FFF , 455px 493px #FFF , 1730px 598px #FFF , 66px 1109px #FFF , 1711px 1601px #FFF , 453px 248px #FFF , 471px 1568px #FFF , 1196px 404px #FFF , 310px 1410px #FFF , 482px 656px #FFF , 229px 86px #FFF , 1228px 787px #FFF , 867px 542px #FFF , 1801px 36px #FFF , 372px 126px #FFF , 704px 978px #FFF , 1407px 341px #FFF , 402px 1283px #FFF , 1292px 109px #FFF , 643px 1827px #FFF , 964px 1506px #FFF , 315px 1541px #FFF , 1292px 190px #FFF , 1416px 1671px #FFF , 762px 1724px #FFF , 1401px 1521px #FFF , 530px 1418px #FFF , 323px 1856px #FFF , 1074px 1869px #FFF , 1654px 1007px #FFF , 594px 979px #FFF , 403px 1196px #FFF , 1840px 1258px #FFF , 627px 464px #FFF , 1791px 245px #FFF , 597px 1816px #FFF , 539px 1227px #FFF , 288px 1520px #FFF , 1065px 1209px #FFF , 709px 1603px #FFF , 216px 972px #FFF , 1682px 1879px #FFF , 1308px 1177px #FFF , 220px 1534px #FFF , 1024px 788px #FFF , 391px 1108px #FFF , 1377px 1124px #FFF , 1681px 1799px #FFF , 772px 1644px #FFF , 223px 1823px #FFF;
  animation: animStar 100s linear infinite;
}
#stars2:after {
  content: " ";
  position: absolute;
  top: 2000px;
  width: 2px;
  height: 2px;
  background: transparent;
  box-shadow: 1414px 1536px #FFF , 192px 1184px #FFF , 495px 10px #FFF , 838px 402px #FFF , 145px 509px #FFF , 1638px 428px #FFF , 102px 1790px #FFF , 1160px 1584px #FFF , 822px 1371px #FFF , 912px 1004px #FFF , 101px 1559px #FFF , 1746px 1540px #FFF , 783px 890px #FFF , 881px 1449px #FFF , 1801px 870px #FFF , 1418px 316px #FFF , 176px 1px #FFF , 979px 79px #FFF , 705px 651px #FFF , 957px 355px #FFF , 379px 1647px #FFF , 746px 1964px #FFF , 579px 486px #FFF , 293px 898px #FFF , 1807px 307px #FFF , 520px 1957px #FFF , 1003px 1855px #FFF , 1333px 1243px #FFF , 1708px 486px #FFF , 532px 717px #FFF , 989px 527px #FFF , 1419px 272px #FFF , 1061px 777px #FFF , 1914px 1822px #FFF , 1442px 989px #FFF , 181px 231px #FFF , 1879px 135px #FFF , 1335px 310px #FFF , 1902px 638px #FFF , 1744px 1085px #FFF , 1528px 814px #FFF , 1607px 173px #FFF , 1403px 155px #FFF , 12px 222px #FFF , 260px 1141px #FFF , 1659px 924px #FFF , 1104px 1637px #FFF , 110px 71px #FFF , 1361px 849px #FFF , 642px 1549px #FFF , 166px 1325px #FFF , 3px 1023px #FFF , 1212px 1179px #FFF , 1680px 1158px #FFF , 263px 1917px #FFF , 584px 181px #FFF , 683px 1837px #FFF , 1862px 1623px #FFF , 1960px 374px #FFF , 23px 407px #FFF , 395px 187px #FFF , 1299px 135px #FFF , 73px 1860px #FFF , 101px 947px #FFF , 1185px 954px #FFF , 136px 1331px #FFF , 240px 1903px #FFF , 156px 939px #FFF , 1068px 1658px #FFF , 1698px 63px #FFF , 468px 1992px #FFF , 1097px 1927px #FFF , 1716px 942px #FFF , 484px 598px #FFF , 301px 1607px #FFF , 1794px 482px #FFF , 1712px 404px #FFF , 655px 1522px #FFF , 363px 795px #FFF , 1114px 653px #FFF , 440px 210px #FFF , 66px 1739px #FFF , 1654px 362px #FFF , 526px 326px #FFF , 629px 1153px #FFF , 842px 1779px #FFF , 617px 1353px #FFF , 1633px 1929px #FFF , 76px 627px #FFF , 292px 607px #FFF , 390px 1753px #FFF , 411px 28px #FFF , 296px 555px #FFF , 390px 226px #FFF , 1984px 1566px #FFF , 1282px 518px #FFF , 665px 981px #FFF , 846px 1560px #FFF , 804px 984px #FFF , 1020px 1939px #FFF , 3px 1222px #FFF , 206px 1208px #FFF , 1623px 1246px #FFF , 734px 757px #FFF , 1320px 1110px #FFF , 498px 1354px #FFF , 973px 412px #FFF , 817px 503px #FFF , 46px 1682px #FFF , 1947px 843px #FFF , 1302px 619px #FFF , 674px 816px #FFF , 292px 758px #FFF , 295px 943px #FFF , 1594px 955px #FFF , 1003px 92px #FFF , 1065px 1984px #FFF , 409px 1501px #FFF , 996px 1354px #FFF , 1911px 1988px #FFF , 1069px 1353px #FFF , 1605px 1848px #FFF , 715px 738px #FFF , 456px 425px #FFF , 400px 543px #FFF , 854px 418px #FFF , 1284px 1219px #FFF , 870px 1707px #FFF , 529px 578px #FFF , 1550px 912px #FFF , 867px 540px #FFF , 355px 956px #FFF , 389px 1865px #FFF , 1137px 29px #FFF , 991px 746px #FFF , 799px 634px #FFF , 1835px 1888px #FFF , 1908px 1282px #FFF , 1151px 1041px #FFF , 1285px 1575px #FFF , 1696px 1080px #FFF , 91px 191px #FFF , 468px 674px #FFF , 598px 369px #FFF , 1695px 32px #FFF , 1485px 1655px #FFF , 188px 1511px #FFF , 255px 430px #FFF , 515px 784px #FFF , 777px 748px #FFF , 1714px 138px #FFF , 455px 493px #FFF , 1730px 598px #FFF , 66px 1109px #FFF , 1711px 1601px #FFF , 453px 248px #FFF , 471px 1568px #FFF , 1196px 404px #FFF , 310px 1410px #FFF , 482px 656px #FFF , 229px 86px #FFF , 1228px 787px #FFF , 867px 542px #FFF , 1801px 36px #FFF , 372px 126px #FFF , 704px 978px #FFF , 1407px 341px #FFF , 402px 1283px #FFF , 1292px 109px #FFF , 643px 1827px #FFF , 964px 1506px #FFF , 315px 1541px #FFF , 1292px 190px #FFF , 1416px 1671px #FFF , 762px 1724px #FFF , 1401px 1521px #FFF , 530px 1418px #FFF , 323px 1856px #FFF , 1074px 1869px #FFF , 1654px 1007px #FFF , 594px 979px #FFF , 403px 1196px #FFF , 1840px 1258px #FFF , 627px 464px #FFF , 1791px 245px #FFF , 597px 1816px #FFF , 539px 1227px #FFF , 288px 1520px #FFF , 1065px 1209px #FFF , 709px 1603px #FFF , 216px 972px #FFF , 1682px 1879px #FFF , 1308px 1177px #FFF , 220px 1534px #FFF , 1024px 788px #FFF , 391px 1108px #FFF , 1377px 1124px #FFF , 1681px 1799px #FFF , 772px 1644px #FFF , 223px 1823px #FFF;
}

#stars3 {
  width: 3px;
  height: 3px;
  background: transparent;
  box-shadow: 442px 1337px #FFF , 1248px 532px #FFF , 1091px 511px #FFF , 384px 633px #FFF , 675px 1776px #FFF , 485px 1011px #FFF , 1004px 1458px #FFF , 805px 1772px #FFF , 1089px 1426px #FFF , 1976px 966px #FFF , 1316px 1410px #FFF , 1223px 612px #FFF , 1239px 189px #FFF , 240px 1143px #FFF , 901px 1251px #FFF , 355px 34px #FFF , 1693px 103px #FFF , 1040px 621px #FFF , 673px 1297px #FFF , 1602px 1696px #FFF , 785px 539px #FFF , 1978px 1303px #FFF , 161px 81px #FFF , 1231px 58px #FFF , 1091px 331px #FFF , 1012px 218px #FFF , 1645px 1373px #FFF , 1355px 855px #FFF , 1096px 891px #FFF , 1243px 1284px #FFF , 1318px 1224px #FFF , 339px 1253px #FFF , 37px 24px #FFF , 1409px 616px #FFF , 942px 1129px #FFF , 1519px 312px #FFF , 800px 1211px #FFF , 212px 1112px #FFF , 1610px 751px #FFF , 1984px 1014px #FFF , 798px 997px #FFF , 1360px 1706px #FFF , 1301px 959px #FFF , 565px 668px #FFF , 1520px 597px #FFF , 1372px 298px #FFF , 268px 1878px #FFF , 1624px 1298px #FFF , 1827px 889px #FFF , 1744px 1879px #FFF , 242px 368px #FFF , 191px 1758px #FFF , 1119px 650px #FFF , 1062px 1336px #FFF , 246px 502px #FFF , 1995px 2px #FFF , 138px 1535px #FFF , 990px 1670px #FFF , 62px 1356px #FFF , 1981px 735px #FFF , 354px 425px #FFF , 696px 1231px #FFF , 1569px 1058px #FFF , 502px 276px #FFF , 1550px 456px #FFF , 584px 107px #FFF , 1998px 250px #FFF , 1272px 753px #FFF , 294px 1913px #FFF , 103px 132px #FFF , 1889px 1194px #FFF , 1740px 1568px #FFF , 1212px 209px #FFF , 1322px 312px #FFF , 1206px 1671px #FFF , 780px 514px #FFF , 1064px 698px #FFF , 1036px 1318px #FFF , 617px 145px #FFF , 907px 903px #FFF , 1874px 1679px #FFF , 1383px 166px #FFF , 686px 1254px #FFF , 891px 1397px #FFF , 386px 1386px #FFF , 716px 201px #FFF , 914px 652px #FFF , 199px 1543px #FFF , 425px 394px #FFF , 446px 539px #FFF , 799px 1817px #FFF , 1033px 938px #FFF , 589px 237px #FFF , 442px 1322px #FFF , 291px 1029px #FFF , 925px 525px #FFF , 1453px 659px #FFF , 1016px 1937px #FFF , 67px 1056px #FFF , 1568px 1111px #FFF;
  animation: animStar 150s linear infinite;
}
#stars3:after {
  content: " ";
  position: absolute;
  top: 2000px;
  width: 3px;
  height: 3px;
  background: transparent;
  box-shadow: 442px 1337px #FFF , 1248px 532px #FFF , 1091px 511px #FFF , 384px 633px #FFF , 675px 1776px #FFF , 485px 1011px #FFF , 1004px 1458px #FFF , 805px 1772px #FFF , 1089px 1426px #FFF , 1976px 966px #FFF , 1316px 1410px #FFF , 1223px 612px #FFF , 1239px 189px #FFF , 240px 1143px #FFF , 901px 1251px #FFF , 355px 34px #FFF , 1693px 103px #FFF , 1040px 621px #FFF , 673px 1297px #FFF , 1602px 1696px #FFF , 785px 539px #FFF , 1978px 1303px #FFF , 161px 81px #FFF , 1231px 58px #FFF , 1091px 331px #FFF , 1012px 218px #FFF , 1645px 1373px #FFF , 1355px 855px #FFF , 1096px 891px #FFF , 1243px 1284px #FFF , 1318px 1224px #FFF , 339px 1253px #FFF , 37px 24px #FFF , 1409px 616px #FFF , 942px 1129px #FFF , 1519px 312px #FFF , 800px 1211px #FFF , 212px 1112px #FFF , 1610px 751px #FFF , 1984px 1014px #FFF , 798px 997px #FFF , 1360px 1706px #FFF , 1301px 959px #FFF , 565px 668px #FFF , 1520px 597px #FFF , 1372px 298px #FFF , 268px 1878px #FFF , 1624px 1298px #FFF , 1827px 889px #FFF , 1744px 1879px #FFF , 242px 368px #FFF , 191px 1758px #FFF , 1119px 650px #FFF , 1062px 1336px #FFF , 246px 502px #FFF , 1995px 2px #FFF , 138px 1535px #FFF , 990px 1670px #FFF , 62px 1356px #FFF , 1981px 735px #FFF , 354px 425px #FFF , 696px 1231px #FFF , 1569px 1058px #FFF , 502px 276px #FFF , 1550px 456px #FFF , 584px 107px #FFF , 1998px 250px #FFF , 1272px 753px #FFF , 294px 1913px #FFF , 103px 132px #FFF , 1889px 1194px #FFF , 1740px 1568px #FFF , 1212px 209px #FFF , 1322px 312px #FFF , 1206px 1671px #FFF , 780px 514px #FFF , 1064px 698px #FFF , 1036px 1318px #FFF , 617px 145px #FFF , 907px 903px #FFF , 1874px 1679px #FFF , 1383px 166px #FFF , 686px 1254px #FFF , 891px 1397px #FFF , 386px 1386px #FFF , 716px 201px #FFF , 914px 652px #FFF , 199px 1543px #FFF , 425px 394px #FFF , 446px 539px #FFF , 799px 1817px #FFF , 1033px 938px #FFF , 589px 237px #FFF , 442px 1322px #FFF , 291px 1029px #FFF , 925px 525px #FFF , 1453px 659px #FFF , 1016px 1937px #FFF , 67px 1056px #FFF , 1568px 1111px #FFF;
}


@keyframes animStar {
  from {
    transform: translateY(0px);
  }
  to {
    transform: translateY(-2000px);
  }
}

.animated {
    -webkit-animation-duration: 0.4s;
    animation-duration: 0.4s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
}
    
@-webkit-keyframes fadeIn {
    0% {opacity: 0;}
    100% {opacity: 1;}
}
    
@keyframes fadeIn {
    0% {opacity: 0;}
    100% {opacity: 1;}
}
    
.fadeIn {
    -webkit-animation-name: fadeIn;
    animation-name: fadeIn;
}


@-webkit-keyframes scale {
    0% {
        -webkit-transform: scale(0);
    }
    50% {
        -webkit-transform: scale(1);
    }
}


.contenu-footer{
  padding-top:15px;
  margin-left:0px;
}

.link-footer{
  color:#639EFB;
  font-weight:bold;
  font-size:16px;

}

.link-footer:hover{
   color: inherit;
    text-decoration:none;
  color:#80ADF4;
  cursor: pointer;  
}

.link-footer:focus{
   color: #80ADF4;
    text-decoration:none;
}

.cadre-addin-footer{
  background-color:#639EFB;
  color:#BCBABA;
  border-radius:5px;
  font-size:12px;
}

button{
  background-color:transparent;
    color: inherit;
 text-decoration:none;
 border-style: none;
}
button:focus {outline:0;}

.app{
  position: relative;
}

.fade-enter-active, .fade-leave-active {
  transition: .13s
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: translate(-100%, 0);

}

.fade2-enter-active, .fade2-leave-active{
  transition: height .20s
}
.fade2-enter, .fade2-leave-to /* .fade-leave-active below version 2.1.8 */ {
  height: 0;

}

.slide-leave-active,
.slide-enter-active {
  transition: 0.20s;
}
.slide-enter {
  transform: translate(0, -100%);
}
.slide-leave-to {
  transform: translate(0, -100%);
}

.slideUp-leave-active,
.slideUp-enter-active {
  transition: 0.20s;
}
.slideUp-enter {
  transform: translate(0, 200%);
}
.slideUp-leave-to {
  transform: translate(0, 200%);
}


.slideLeft-leave-active,
.slideLeft-enter-active {
  transition: 1s;
}
.slideLeft-enter {
  transform: translate(100%, 0);
}
.slideLeft-leave-to {
  transform: translate(-100%, 0);
}

.rotate-leave-active,
.rotate-enter-active {
  transition: 0.1s;
}
.rotate-enter {
  transform: rotate(-90deg);
}
.rotate-leave-to {
  transform: rotate(-90deg);
}

.nopadding {
   padding: 0 !important;
   margin: 0 !important;
}

.row-1{
  width:100%;
  margin-left:0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue